// This file is auto-generated with `pnpm fetchTranslations`

export const translation = {
  ANewCalibrationCertificateIsAvailableFor:
    'A new calibration is available for {{name}} | {{iuid}} (SN {{serialNumber}})',
  ANewCalibrationCertificateIsAvailableMsg:
    'A new calibration is available. Please ensure connectivity of UNICHECK Software to the PTW Cloud services. After activating the new calibration,  all reference measurements that were performed with this QA equipment must be renewed.',
  ANewUpdateIsAvailable: 'A new update is available',
  ANewUpgradeIsAvailable: 'A new upgrade is available',
  Abbreviation: 'Abbreviation',
  AboutPtw100: 'About UNICHECK',
  AbsoluteValuesMsg:
    'The displayed \'absolute\' reference values are derived from a UNICHECK measurement. Comparisons with absolute values measured with other QA devices may show deviations. \n\nThe quantities "Stability index (x/y)" and "Beam profile constancy" are not displayed here because their values can only be calculated when comparing a measurement with a reference measurement.\n',
  Accept: 'Accept',
  AccountAddedSuccessfullyMsg: '{{userFullNameWithIuid}} added',
  AccountSuccessfullyActivatedMsg:
    'Your user account has been activated successfully.\nYou can now sign in to UNICHECK Software.',
  Acknowledged: 'Ignore',
  Activate: 'Activate',
  ActivateAccount: 'Account activation',
  ActivateCertificate: 'Activate calibration certificate',
  ActivateInstallation: 'Activate installation',
  ActivateMaintenanceMode: 'Activate maintenance mode',
  ActivateNewCalibrationCertificate: 'Activate new calibration',
  ActivateNewCalibrationCertificateSuccessMsg: 'A new calibration has been activated.',
  ActivateNow: 'Activate now',
  ActivatedBy: 'Activated by',
  Activation: 'Activation',
  ActivationDate: 'Activation date',
  ActivationInfoMsg:
    'In order to be able to sign in, the user has to open the activation link and set the password.',
  ActivationLinkSentButNoActivatedYetResendMsg:
    'This user has received an account activation link but has not activated the user account yet.',
  ActivationMsg:
    'The installation can be completed in just a few steps. To ensure that your installation has not been installed already you need to activate it. You may need your myPTW credentials to do so.',
  ActivationPossibleInfoMsg: 'Sign in is only possible for enabled user accounts.',
  ActivationSuccessful: 'Installation activated',
  Add: 'Add',
  AddAComment: 'Add a comment...',
  AddAdditionalQaEquipment: 'Add additional dosimetry and QA equipment',
  AddAndSelect: 'Apply',
  AddAttachments: 'Add attachments',
  AddBeamQuality: 'Add beam quality',
  AddBeamShapingParameter: 'Add beam shaping',
  AddBeamShapingParametersTooltip:
    'Additional parameters cannot be added. The task type is intended for daily constancy checks of linear accelerators with 10 cm x 10 cm and/or 20 cm x 20 cm field sizes by means of the UNICHECK measuring device.',
  AddComment: 'Comment',
  AddDefinition: 'Add definition',
  AddDefinitionParameter: 'Add definition parameter',
  AddDefinitionParameterSet: 'Add definition parameter preset',
  AddDosimetryAndQaEntity: 'Select QA equipment model',
  AddDosimetryAndQaEquipment: 'Add QA equipment',
  AddDosimetryQaEntity: 'Add QA equipment',
  AddDosimetryQaSetupEntity: 'Add QA equipment setup',
  AddEnumerationItem: 'Add',
  AddEvaluation: 'Add evaluation',
  AddEvaluationGeometry: 'Add',
  AddEvaluationQuantity: 'Add evaluation quantity',
  AddFirst: 'Add first',
  AddJob: 'Add job',
  AddJobEntity: 'Add job configuration',
  AddLocationsEntity: 'Add location entity',
  AddMedicalSystem: 'Select medical system',
  AddMedicalSystemEntity: 'Add medical system',
  AddMedicalSystemSetupEntity: 'Add medical system setup',
  AddMedicalSystemTaskEntity: 'Add task',
  AddMedicalSystemToJobMsg: 'Select a medical system for which this job is to be executed.',
  AddMedicalSystemToTaskMsg: 'Select a medical system for which this task is to be performed.',
  AddParameter: 'Add parameter',
  AddQuantity: 'Add quantity',
  AddRole: 'Add role',
  AddSetupGeometry: 'Add',
  AddSetupParameter: 'Select setup parameter',
  AddTargetArea: 'Add target area',
  AddTargetAreaToJobConfiguration: 'Add a target area to configure your job.',
  AddTargetAreaToTaskConfiguration: 'Add a target area to configure your task.',
  AddTask_one: 'Add task',
  AddTask_other: 'Add tasks',
  AddTasksToJobMsg: 'Select the work items to be executed in this job.',
  Added: 'Added',
  AddedComment: 'Comment added',
  AddedEnumeration: 'Enumeration added',
  AddedUnit: 'Unit added',
  AdditionalParameters: 'Additional parameters',
  AdditionalParametersMsg:
    'You can set additional parameters, for example: "Connect Timeout=30;", etc.',
  AdditionalSetupInstructions: 'Additional setup instruction',
  Address: 'Address',
  AdjustValuesInMeasurement: 'Adjust values in measurement',
  AdminAccountAdded: 'Admin account added.',
  AdministrativeInformation: 'Administration',
  AdvancedSettings: 'Advanced settings',
  AirPressure: 'Air pressure',
  AirTemperature: 'Air temperature',
  All: 'All',
  AllDay: 'All day',
  AllowSuspensionOf: 'Allow suspension of',
  AlreadyExistingDatabaseWillBeMigratedMsg:
    'Before proceeding please check the following:\n• If the target database already exists, please ensure that you have created a backup of that database.\n• If the target database comes from an older version of UNICHECK Software, it will be automatically migrated to match your current version.\n• All data from the current in-use database will no longer be available in UNICHECK Software after change is done.\n• The current in-use database itself will not be modified or removed.\n• All data, including user credentials, will be taken from the new database.\n• If the current user does not already exist in the target database, the user will be added automatically.\n• The current user will be assigned the "IT administrator" role in the target database.',
  AnErrorOccurred: 'An error occurred, please try again later.',
  And_count_MoreParameter_one: 'and one more parameter',
  And_count_MoreParameter_other: 'and {{count}} more parameters',
  Any: 'Any',
  Application: 'Application',
  ApplicationConnectionString: 'App connection string',
  ApplicatorType: 'Applicator type',
  Apply: 'Apply',
  ApprovalStatus: 'Approval status',
  Approve: 'Approve',
  ApprovedBy: 'Approved by',
  Archive: 'Archive',
  ArchiveDescriptionMsg: 'Long-term storage of data that is no longer actively used.',
  ArticleNumber: 'Reference number',
  AsSoonAsTheAccountIsActivated:
    'As soon as the admin account is saved changes can only be made in the settings.',
  AssignGroupName: 'Assign group name',
  AssignedRoles: 'Roles',
  AssignedToRole: 'Roles',
  AssignedToUser: 'Users',
  Assignment: 'Assigned to',
  AssignmentRequestMessagePlaceholder: 'Your message (optional)',
  AtLeastOneDefinitionParameterMustBeDefined:
    'In order to create a definition parameter preset, at least one definition parameter must be provided in the definition.',
  AtLeastOneEnergyMustBeSelected: 'At least one beam quality must be selected.',
  AtLeastOneEvaluationMustBeEnabled: 'At least one quantity/enumeration must be selected.',
  AtLeastOneEvaluationMustBeSelected: 'At least one quantity/enumeration must be selected.',
  AtLeastOneParameterValueSetIsRequired: 'At least one definition parameter preset is required.',
  Attachment_one: 'Attachment',
  Attachment_other: 'Attachments',
  Attachments: 'Attachments',
  Attempt_one: 'attempt',
  Attempt_other: 'attempts',
  AuditLog: 'Audit Log',
  Availability: 'Availability',
  Available: 'Available',
  AvailableDoseRates: 'Available dose rates',
  AvailableDoseRatesForStaticBeams: 'Available dose rates',
  AvailableElectronBeamQualities: 'Available electron beam qualities and dose rates',
  AvailableForUse: 'Available for use',
  AvailablePhotonBeamQualities: 'Available photon beam qualities and dose rates',
  AvailablePtw100SoftwareVersion: 'Available software version {{version}}',
  AvailibilityOfRoleOfCurrentUserCanNotBeChangedMsg:
    'Availability of the current user role cannot be changed.',
  Back: 'Back',
  BackToOverview: 'Back to overview',
  Backup: 'Backup',
  BackupAndRestore: 'Backup and restore',
  BackupFiles: 'Backup files',
  BackupFilesDeletedSuccessfully: 'Successfully deleted {{count}} backup file(s)',
  BackupFilesDeletionFailed: 'Failed to delete {{count}} backup file(s)',
  BackupRestoreWarningMsg:
    'Warning: If you plan to back up the integrated database and restore it into a custom database, we strongly recommend to activate maintenance mode beforehand. This will prevent data loss caused by other users creating or modifying data during the process.',
  Battery: 'Battery',
  BatteryRemaining: '{{capacity}} ({{remainingDuration}})',
  Beam: 'Beam properties',
  BeamLimitingDeviceType: 'Beam-limiting device type',
  BeamProduction: 'Beam production',
  BeamQuality: 'Beam quality',
  BeamQualityParameters: 'Beam quality and dose rate',
  BeamShapingGroup: 'Beam shaping',
  BeamShapingParameters: 'Beam shaping',
  Bin: 'Bin',
  BinDescriptionMsg: 'Storage of deleted data with the option to restore or permanently delete it.',
  Blob: 'Blob',
  BlobConnectionString: 'Blob connection string',
  Brand: 'Brand',
  BrandEnum: {
    BEAMSCANBrand: 'BEAMSCAN',
    COUCHFIXBrand: 'COUCHFIX',
    MicroDiamondBrand: 'microDiamond',
    NOMEXBrand: 'NOMEX',
    OCTAVIUSBrand: 'OCTAVIUS',
    RUBYBrand: 'RUBY',
    STARCHECKBrand: 'STARCHECK',
    TRUFIXBrand: 'TRUFIX',
    UNICHECKBrand: 'UNICHECK',
    UNIDOSBrand: 'UNIDOS',
  },
  By: 'by',
  CalibratedBy: 'Calibration laboratory',
  Calibration: 'Calibration',
  CalibrationAndDevice: 'Calibration',
  CalibrationCertificateInvalid: 'Calibration invalid',
  CalibrationCertificateMissing: 'Calibration missing',
  CalibrationCertificateMissingFor:
    'Calibration missing for {{name}} | {{iuid}} (SN {{serialNumber}})',
  CalibrationCertificateNo: 'Calibration Certificate No.',
  CalibrationCertificateOutdated: 'Calibration outdated',
  CalibrationDataAirPresure: 'Air pressure',
  CalibrationDataBeamQuality: 'Beam quality',
  CalibrationDataMeasuringQuantity: 'Measuring quantity',
  CalibrationDataReferenceTemperature: 'Temperature',
  CalibrationDataSourceEnum: { LocalUpload: 'Local upload', PtwCloud: 'PTW Cloud' },
  CalibrationDate: 'Calibration date',
  CalibrationFile: 'Calibration file',
  CalibrationInformation: 'Current calibration information',
  CalibrationInformationOnlyWhenDeviceRegisteredMsg:
    'Calibration information will be updated upon registration of the device.',
  CalibrationLaboratory: 'Calibration laboratory',
  CalibrationMissing: 'Calibration is missing',
  CalibrationMissingMsg: 'Calibration missing',
  CalibrationMissingTitle: 'Calibration missing',
  CalibrationObject: 'Calibration object',
  CalibrationOutdatedMsg: 'Calibration outdated',
  CalibrationState: 'Calibration state',
  CalibrationType: 'Calibration type',
  CanTakeUptoXMinutes: 'This can take up to {{durationInMinutes}} minutes.',
  Cancel: 'Cancel',
  CancelUpload: 'Cancel upload',
  CannotDeleteQaEquipmentBecauseIsOrWasRegistered:
    'This QA equipment cannot be deleted because it has already been registered.',
  Category_one: 'Category',
  Category_other: 'Categories',
  Cause: 'Cause',
  CertificateExpiration: 'Certificate expiration',
  ChamberWithNumber: 'Chamber {{number}}',
  ChambersDeactivatedCount: '{{deactivated}} of {{total}} chambers deactivated',
  ChangePassword: 'Change password',
  ChangeTargetSystemWarningMsg:
    'When switching the medical system, only work items with a matching target area can be applied. All other work items must be removed.',
  ChangesOnlyInPlatformSettingsMsg:
    'As soon as the admin account is saved, changes can only be made in the settings.',
  ChangesWontBeSavedMsg:
    'You have modified this item. When you leave this page all changes are discarded.',
  ChangingFeatures: 'Changing features',
  CheckForNewUpdates: 'Check for updates',
  CheckForNewVersions: 'Check for new versions',
  CheckUpdateState: 'Check update state',
  CheckUpgradeState: 'Check upgrade state',
  CheckYourEmail: 'Email sent',
  ChooseDataType: 'Select data type',
  ChooseInputSensorDataForMeasurement: 'Choose input sensor data for measurement',
  ChooseModel: 'Select medical system model',
  ChooseOtherManufacturerQaEquipmentModel: 'Select model',
  ChooseTask: 'Add task',
  ClearAllPermissions: 'Clear all permissions',
  ClearFilters: 'Clear filters',
  Close: 'Close',
  CollapseAll: 'Collapse all',
  CollapseAllPermissionPanels: 'Collapse all',
  Comment_one: 'Comment',
  Comment_other: 'Comments',
  Comments: 'Comments',
  CommonConfirmationForEntitiesWithRefMsg:
    'Are you sure you want to save the changes?\n\nThe modifications will be synchronized with all relevant entities.',
  CompanyID: 'Company ID',
  CompleteInstallation: 'Complete installation',
  Completed: 'Completed',
  Configuration: 'Configuration',
  ConfigureAndTestEmailSettings: 'Configure and test email settings',
  ConfigureEvaluationQuantity: 'Configure quantity',
  Confirm: 'Confirm',
  ConfirmDeleteEntityMsg:
    'Are you sure you want to delete this {{entityName}}? \nThis action cannot be undone.',
  ConfirmNext: 'Confirm & Next',
  Confirmation: 'Confirmation',
  Congratulations: 'Congratulations',
  Connection: 'Connection',
  ConnectionFailed: 'Connection failed',
  ContactAdminBecauseOfErrorMsg: 'Sorry, something went wrong.\nPlease contact your administrator.',
  ContactPtwCustomerSupport: 'Contact PTW support',
  ContinueJobExecution: 'Continue',
  Copy: 'Duplicate',
  CorrectionFactorKUser: 'Correction factor (k_user)',
  Corrections: 'Corrections',
  Create: 'Create',
  CreateABackupMsg:
    'You can create a backup of your integrated data base.\n\nImportant:\nCurrent SQL Server version:\nMicrosoft SQL Server 2022 (RTM-CU13) (KB5036432) - 16.0.4125.3 (X64)\n\nBackups can only be restored on this version of SQL Server or a newer one.',
  CreateACustomDatabaseMsg: 'This choice will create a new database.',
  CreateAdminAccount: 'Create admin account',
  CreateBackupConfirmation:
    'Are you sure you want to create a new database backup?\n\nThis operation may take some time to complete.',
  CreateDatabaseBackup: 'Create Database Backup',
  CreationDate: 'Creation date',
  CurrentCalibrationCertificate: 'Current calibration',
  CurrentPassword: 'Current password',
  CurrentPtw100SoftwareVersion: 'Current software version {{version}}',
  CustomDatabase: 'Custom database',
  CustomDatabaseUsedMsg:
    'You are using an external custom database already.\n\nThe backup functionality is only available for the integrated SQL Server.',
  Customer: 'Customer',
  DICOM: 'DICOM',
  DPIN: 'DPIN',
  DailyCheckWithUnicheckMsg:
    'This task type is intended for daily constancy checks of linear accelerators by means of the UNICHECK measuring device. It is not intended for tuning or absolute measurement of radiation field properties. The user is responsible for appropriate task configuration.',
  Dashboard: 'Dashboard',
  Dashboards: 'Dashboard',
  DataSet: 'Data set',
  DataType_one: 'Data type',
  DataType_other: 'Data types',
  Database: 'Database',
  DatabaseBackup: 'Database backup',
  DatabaseBackupFailed: 'Database backup failed',
  DatabaseBackupSucceeded: 'Database backup succeeded',
  DatabaseConfiguration: 'Database configuration',
  DatabaseConfigurationMsg:
    'The application is currently working with an integrated Microsoft SQL Server – Express edition.\nThis is sufficient for a test phase or demo purposes.',
  DatabaseConnected: 'Database connected',
  DatabaseErrorMsg: 'Something went wrong. Please check and try again.',
  DatabaseProductionWarningMsg:
    'The integrated data base is only for test or demo purposes. For use in a production environment, it is highly recommended to configure a custom database. Please do not use the integrated database in a production environment.',
  DatasetsFound: 'data sets found',
  Date: 'Date',
  DateOfExpiration: 'Expiration date',
  DateOfIssue: 'Issue date',
  DateOfPublication: 'Publication date',
  DayOfWeek: {
    Monday: 'Mo',
    Tuesday: 'Tu',
    Wednesday: 'We',
    Thursday: 'Th',
    Friday: 'Fr',
    Saturday: 'Sa',
    Sunday: 'Su',
  },
  Day_one: 'Day',
  Day_other: 'Days',
  DeRegistered: 'deregistered',
  DeRegistrationFailed: 'Deregistration failed',
  DeactivateMaintenanceMode: 'Deactivate maintenance mode',
  DeactivatedByPtw: 'Deactivated by PTW (DC)',
  DeactivatedByUser: 'Deactivated by user (UC)',
  DeactivatedChambers: 'Deactivated chambers',
  DeactivatedChambersExcludedMsg:
    'The following chambers were deactivated with the active calibration and are excluded from measurements.',
  DefaultFromSenderDisplayName: 'Default from (sender) display name',
  DefaultFromSenderEmailAddress: 'Default from (sender) email address',
  DefaultSupportSystemGroup: 'Default support system group',
  DefaultValue: 'Default value',
  DefaultValues: 'Default values',
  DefineAnInstallationName: 'Define an installation name',
  DefinitionDescriptionEnum: {
    RadFieldSizeWRefToCaxDoseMsg:
      'The dosimetric field size is determined as follows:\n1) Fit the penumbras to an equation around the nominal field edge with the fit function presented in the equation of NCS Linac QA Report (3). \n2) Define the field edges at the predetermined percentage of the absorbed dose value on the central axis within the fitted penumbra region. \n3) The dosimetric field size is the lateral distance between the two field edges.',
    RadFieldSizeAtInflectionPointsMsg:
      'The dosimetric field size is determined as follows:\n1) Fit the penumbras to an equation around the nominal field edge with the fit function presented in the equation of NCS Linac QA Report (3).\n2) The location of the maximum gradient in this fit, also called the inflection point (INFL), defines the field edges. \n3) The dosimetric field size is the lateral distance between the two field edges.',
    RadFieldEdgeWRefToCaxDoseMsg:
      'The radiation field edge is defined as the measurement position where the absorbed dose is the predetermined percentage of the absorbed dose value on the central axis.',
    RadFieldEdgeAtInflectionPointsMsg:
      'The radiation field edge is defined as the position of a local extremum of the first derivation from a high resolution and mean filtered dose profile. The local extremum is one of the inflection points IP_L and IP_R.',
    PenumbraWidthWRefToCaxDoseMsg:
      'Penumbra based on IEC 60976: 2007-10, 9.3.1, whereby the penumbra  is defined by the distance along the major axes between the defined lower percentage and upper percentage points of the absorbed dose value on the central axis.',
    PenumbraWidthWRefToEqualizedInflectionPointsMsg:
      'For determining the radiation beam penumbra, the dose value at IP shall be taken as the reference dose value (RDV). Points Pa and Pb, which are located at 1.6 and 0.4 times of RDV, respectively, shall be identified [Figure 1]. Lateral separation between Pa and Pb on either side of the profile will be the measure of the radiation beam penumbra."  G Sahani1, SD Sharma2, PK Dash Sharma1, DD Deshpande3, PS Negi4, VK Sathianarayanan5,\nGK Rath. Acceptance criteria for flattening filter-free photon beam from standard medical electron linear  accelerator: AERB task group recommendations, Year : 2014 | Volume : 39 | Issue : 4 | Page : 206-211',
    SymmetryByMaxDoseRatioMsg:
      'The profile symmetry based on IEC 60976: 2007-10, 9.1.3. is defined as the maximum value of the ratio of the higher to the lower absorbed dose at any two positions symmetrical to the radiation beam axis and inside the flattened area. \n\nThe size of the flattened area is defined for three ranges of radiation field sizes. In each range, a further distinction is made as to whether the profile symmetry is derived from a dose profile on the main axis or the diagonal.\n\nIf used with the default values for the definition parameters, an evaluation quantity can represent the profile symmetry according to  IEC 60976 : 2007-10, 9.1.3.',
    SymmetryByMaxDoseRatioWRefToInflectionPointsMsg:
      'The profile symmetry is defined as the maximum ratio of the absorbed dose measured at points equidistant from the radiation beam axis up to 80 % of the field size, whereby the filed size is the lateral distance of the positions of the local extrema of the first derivation from a high resolution and mean filtered dose profile. The local extrema are the inflection points IP_L and IP_R.',
    BeamProfileConstancyAAPM_TG142_20090817Msg:
      'The beam profile constancy is determined by comparison of the off-axis-ratios in a 2D dose distribution and the off-axis-ratios in a 2D reference dose distribution. The off-axis ratios are determined at the same positions in both dose distributions that fall within the core of the field which is defined as 80 % of the nominal radiation field size.\n\nThe beam profile constancy is calculated according to the standard AAPM TG-142: 2009-08.',
    FlatnessByMaxDoseRatioMsg:
      'Profile flatness based on IEC 60976: 2007-10, 9.1.1, whereby the flatness is the maximum value of the ratio of the maximum absorbed dose to the minimum absorbed dose in the flattened area.\n\nIf used with the default values for the definition parameters, an evaluation quantity can represent the profile flatness according to  IEC 60976 : 2007-10, 9.1.1.',
    AreaSymmetryByMaxDoseRatioMsg:
      'The area or 2D symmetry for square radiation fields based on IEC 60976: 2007-10. is defined as the maximum value of the ratio of the higher to the lower absorbed dose at any two positions symmetrical to the radiation beam axis and inside the flattened 2D area.\n\nThe size of the flattened area is defined for three ranges of radiation field sizes. In each range, a further distinction is made as to whether the symmetry is derived from a dose profile on the main axis or the diagonal.\n\nIf used with the default values for the definition parameters, an evaluation quantity can represent the area or 2D symmetry according to  IEC 60976: 2007-10.',
    AreaFlatnessByMaxDoseRatioMsg:
      'Area or 2D flatness for square radiation fields based on IEC 60976: 2007-10, whereby the 2D flatness is the maximum value of the ratio of the maximum absorbed dose to the minimum absorbed dose in the flattened 2D area.\n\nIf used with the default values for the definition parameters, an evaluation quantity can represent the profile flatness according to  IEC 60976: 2007-10.',
    BeamDoseOutputMsg: 'Beam dose output',
    NominalPhotonBeamEnergyMsg:
      'The nominal photon beam energy is a specified quantity of the energy of the photon beam produced by a linac, typically expressed in megavolts [MV].',
    PercOfAbsDoseMsg: 'Isodose level',
    SamplingResolutionMsg: 'Spatial resolution of a dose profile',
    MeanFilterWidthMsg: 'Kernel size of a mean filter',
    PenumbraWidthRegionLowMsg: 'Lower percentage of absorbed dose',
    PenumbraWidthRegionHighMsg: 'Upper percentage of absorbed dose',
    FlattenedAreaLowerRangeSmallRadiationFieldsMsg:
      'Lower limit of the field size definition range for small radiation fields.',
    FlattenedAreaLowerRangeMidRadiationFieldsMsg:
      'Lower limit of the field size definition range for medium-sized radiation fields.',
    FlattenedAreaLowerRangeLargeRadiationFieldsMsg:
      'Lower limit of the field size definition range for large radiation fields.',
    FlattenedAreaDmSmallMsg:
      'Distance from the nominal radiation field edge to the boundary of the evaluation area (in-field area) along the main axis of a small radiation field.',
    FlattenedAreaDdSmallMsg:
      'Distance from the nominal radiation field edge to the boundary of the evaluation area (in-field area) along the diagonal axis of a small radiation field.',
    FlattenedAreaDmMidMsg:
      'Scaling factor that defines the distance from the nominal radiation field edge to the boundary of the in-field area along the main axis of a medium-sized radiation field relative to the nominal field size.',
    FlattenedAreaDdMidMsg:
      'Scaling factor that defines the distance from the nominal radiation field edge to the boundary of the in-field area along the diagonal axis of a medium-sized radiation field relative to the nominal field size.',
    FlattenedAreaDdLargeMsg:
      'Distance from the nominal radiation field edge to the boundary of the evaluation area (in-field area) along the diagonal axis of a large radiation field.',
    FlattenedAreaDmLargeMsg:
      'Distance from the nominal radiation field edge to the boundary of the evaluation area (in-field area) along the main axis of a large radiation field.',
    NominalElectronBeamEnergyMsg:
      'The nominal electron beam energy is a specified quantity of the energy of the electron beam produced by a linac, typically expressed in megaelectronvolts [MeV].',
    BeamQualityFactorUnicheckMsg:
      'UNICHECK-specific beam quality factors for various radiation types and energy ranges. Depending on the radiation type and energy range, one of four BQF detectors is used to calculate the beam quality factor BQF (= beam quality factor of given radiation type and energy)',
    UnicheckAirTemperatureMsg:
      'The air temperature is measured by UNICHECK internal temperature sensors.',
    UnicheckAirPressureMsg:
      'The air pressure is measured by UNICHECK internal air pressure sensors.',
    StabilityIndexAnsmMsg:
      'Quantitative index 𝑆 used to determine the maximum variation of a dose profile in the core zone with respect to a reference profile established during the initial internal quality control.',
    RadFieldSizeNcsReport33Msg:
      'The field edges and field size are determined as follows:\n1) Fit the penumbras to an equation around the nominal field edge. We propose the fit function presented in equation (3).\n2) The location of the maximum gradient in this fit, also called the inflection point (INFL), defines the field edge.\n3) The field size is the distance between the two field edges.',
    RadFieldEdgeNcsReport33Msg:
      'The field edges and field size are determined as follows:\n1) Fit the penumbras to an equation around the nominal field edge. We propose the fit function presented in equation (3).\n2) The location of the maximum gradient in this fit, also called the inflection point (INFL), defines the field edge.\n3) The field size is the distance between the two field edges.',
    CAXDeviationByRadFieldSizeMsg:
      'The "CAX deviation" is the deviation between the left and the right edge of the radiation field to the central axis.',
    SymmetryIsodoseMsg:
      'The symmetry of a dose profile in an electron beam is defined as the maximum value of the ratio of the higher to the lower dose value at positions that are symmetrical to the radiation beam axis and within a defined area of the dose profile. \n\nThis definition is based on IEC 60976: 2007-10 and follows recommendations of NCS Linac QA report: 2020-07.',
    StabilityIndexAnsmPenumbraFitINFLMsg:
      'The stability index is determined by the maximum dose variation in the core zone of a 1D dose profile (80 % of the radiation field size defined by the distance between the inflection points) with respect to a reference dose profile.\n\nThis definition is based on ANSM: 2023-02 and follows recommendations of NCS Linac QA report: 2020-07.',
    StabilityIndexAnsmPenumbraFitLevelMsg:
      'The stability index is determined by the maximum dose variation in the core zone of a 1D dose profile (80 % of the radiation field size defined at a specific isodose level (typically 50 %)) with respect to a reference dose profile.\n\nThis definition is based on ANSM: 2023-02.',
    CAXDeviationPenumbraFitLevelMsg:
      'The CAX deviation of a dose profile in a photon beam with flattening filter or an electron beam is defined as the deviation of the center of the calculated radiation field (defined at a specific isodose level (typically 50 %)) from the central beam axis. \n\nThis definition follows recommendations of NCS Linac QA report: 2020-07.',
    CAXDeviationPenumbraFitINFLMsg:
      'The CAX deviation of a dose profile in a photon beam without flattening filter is defined as the deviation of the center of the calculated radiation field (defined by the distance between the inflection points) from the central beam axis. \n\nThis definition follows recommendations of NCS Linac QA report: 2020-07.',
    RadFieldSizeByPenumbraFitLevelMsg:
      'The radiation field size of a dose profile in a photon beam with flattening filter or an electron beam is defined at a specific isodose level (typically 50 %). This is often referred to as the full width at half maximum (FWHM).\n\nThis definition follows recommendations of NCS Linac QA Report: 2020-07.',
    RadFieldSizeByPenumbraFitINFLMsg:
      'The radiation field size of a dose profile in a photon beam without flattening filter is defined by the distance between the inflection points.\n\nThis definition follows recommendations of NCS Linac QA Report: 2020-07.',
    SymmetryAreaMsg:
      'The symmetry of a dose profile in a photon beam with flattening filter is defined as the maximum value of the ratio of the higher to the lower dose at any two positions symmetrical to the radiation beam axis and inside a defined area in the dose profile.\n\nThis definition is based on IEC 60976: 2007-10 and follows recommendations of NCS Linac QA Report: 2020-07.',
    SymmetryPercOfFSMsg:
      'The symmetry of a dose profile in a photon beam without flattening filter is defined as the maximum value of the ratio of the higher to the lower dose value at positions symmetrical to the radiation beam axis and within a defined area of the dose profile. \n\nThis definition follows recommendations in Elekta LINAC CAT: 2020-03.',
    PercOfNominalFSMsg: 'Percentage of nominal field size',
    IsodoseDminMsg:
      'Distance from the radiation field edge to the boundary of the evaluation area used for determination of the symmetry.',
    NonSpecificDoseMsg:
      'A non-specific dose is an undefined absorbed dose which cannot be related to an absorbed dose\ndetermined under reference conditions with a secondary normal (such as Co-60).',
    FlatnessAreaRatioMsg:
      'The flatness of a dose profile in a photon beam is defined as the maximum value of the ratio of maximum dose value within the nominal radiation field edges to the minimum dose value within a defined area of the dose profile.\n\nThis definition is based on IEC 60976: 2007-10 and follows recommendations of NCS Linac QA Report: 2020-07.',
    FlatnessCAXRatioMsg:
      'The electron profile flatness of dose profiles is the maximum value of the ratio of the maximum absorbed dose value within the nominal radiation field edges to the dose value at the central axis position .\n\nThis definition is based on IEC 60976: 2007-10 and follows recommendations of NCS Linac QA report: 2020-07.',
    AreaFlatnessAreaRatioMsg:
      'The area flatness of a 2D dose distribution of a photon beam is the maximum value of the ratio of the maximum absorbed dose value within the nominal radiation field edges to the minimum absorbed dose value within a defined area of the 2D dose distribution.\n\nThis definition is based on IEC 60976: 2007-10 and follows recommendations of NCS Linac QA Report: 2020-07.',
    AreaFlatnessCAXRatioMsg:
      'The area flatness of a 2D dose distribution of an electron beam is the maximum value of the ratio of maximum absorbed dose value within the nominal radiation field edges to the dose value at the central axis (CAX) position.\n\nThis definition is based on IEC 60976: 2007-10.\n',
    HorizontalChamberDistanceMsg:
      'Horizontal distance of the BQF chamber to the origin of the detector coordinate system',
    VerticalChamberDistanceMsg:
      'Vertical distance of the BQF chamber to the origin of the detector coordinate system',
  },
  DefinitionLabelEnum: {
    RadFieldSizeWRefToCaxDose:
      'Dosimetric field size according to NCS Linac QA Report determined with reference to the central axis dose.',
    RadFieldSizeAtInflectionPoints:
      'Dosimetric field size according to NCS Linac QA Report determined at inflection points',
    RadFieldEdgeWRefToCaxDose: 'Radiation field edge with reference to the central axis dose',
    RadFieldEdgeAtInflectionPoints: 'Radiation field edge at inflection point',
    PenumbraWidthWRefToCaxDose: 'Penumbra width with reference to the central axis dose',
    PenumbraWidthWRefToEqualizedInflectionPoints:
      'Penumbra width with reference to equalized inflection points',
    SymmetryByMaxDoseRatio: 'Profile symmetry based on IEC 60976: 2007-10',
    SymmetryByMaxDoseRatioWRefToInflectionPoints:
      'Profile symmetry by maximum dose ratio with reference to inflection points',
    BeamProfileConstancyAAPM_TG142_20090817: 'Beam profile constancy (AAPM-TG142: 2009-08)',
    AreaSymmetryByMaxDoseRatio: 'Area or 2D symmetry based on IEC 60976: 2007-10',
    AreaFlatnessByMaxDoseRatio: 'Area or 2D flatness based on IEC 60976: 2007-10, 9.1.1',
    BeamDoseOutput: 'Beam dose output',
    NominalPhotonBeamEnergy: 'Nominal photon beam energy',
    PercOfAbsDose: 'IDL',
    SamplingResolution: 'Spatial resolution',
    MeanFilterWidth: 'Mean filter width',
    PenumbraWidthRegionLow: 'Lower percentage of absorbed dose',
    PenumbraWidthRegionHigh: 'Upper percentage of absorbed dose',
    FlattenedAreaLowerRangeSmallRadiationFields: 'F (small)',
    FlattenedAreaLowerRangeMidRadiationFields: 'F (med)',
    FlattenedAreaLowerRangeLargeRadiationFields: 'F (large)',
    FlattenedAreaDmSmall: 'Dm (small)',
    FlattenedAreaDdSmall: 'Dq (small)',
    FlattenedAreaDmMid: 'dm (med)',
    FlattenedAreaDdMid: 'dq (med)',
    FlattenedAreaDdLarge: 'Dq (large)',
    FlattenedAreaDmLarge: 'Dm (large)',
    NominalElectronBeamEnergy: 'Nominal electron beam energy',
    BeamQualityFactorUnicheck: 'Beam quality factor for UNICHECK',
    UnicheckAirTemperature: 'Determination by UNICHECK',
    UnicheckAirPressure: 'Determination by UNICHECK',
    RadFieldSizeNcsReport33: 'Dosimetric field size determined according to NCS Linac QA Report',
    StabilityIndexAnsm: 'Stability index according to ANSM: 2023-02',
    RadFieldEdgeNcsReport33: 'Radiation field edge determined according to NCS Linac QA Report',
    CAXDeviationByRadFieldSize: 'Central axis deviation',
    CAXDeviationPenumbraFitLevel: 'Isodose level (NCS Linac QA Report: 2020-07)',
    HorizintalChamberDistance: 'Horizontal chamber distance',
    VerticalChamberDistance: 'Vertical chamber distance',
    RadFieldSizeByPenumbraFitLevel: 'Isodose level (NCS Linac QA Report: 2020-07)',
    SymmetryArea: 'Photon profile symmetry (IEC 60976: 2007-10)',
    NonSpecificDose: 'Non specific dose',
    StabilityIndexAnsmPenumbraFitLevel: 'Isodose level (ANSM: 2023-02)',
    FlatnessAreaRatio: 'Photon profile flatness (IEC 60976: 2007-10)',
    AreaFlatnessAreaRatio: 'Photon area flatness (IEC 60976: 2007-10)',
    RadFieldSizeByPenumbraFitINFL: 'Inflection points (NCS Linac QA Report: 2020-07)',
    CAXDeviationPenumbraFitINFL: 'Inflection points (NCS Linac QA Report: 2020-07)',
    SymmetryPercOfFS: 'Photon FFF profile symmetry (Elekta LINAC CAT: 2020-03)',
    PercOfNominalFS: 'Pnom',
    StabilityIndexAnsmPenumbraFitINFL: 'Inflection points (ANSM: 2023-02)',
    SymmetryIsodose: 'Electron profile symmetry (IEC 60976: 2007-10)',
    AreaFlatnessCAXRatio: 'Electron area flatness (IEC 60976: 2007-10)',
    HorizontalChamberDistance: 'Horizontal chamber distance',
    FlatnessCAXRatio: 'Electron profile flatness (IEC 60976: 2007-10)',
    IsodoseDmin: 'Dmin',
  },
  DefinitionParameterName: 'Definition parameter',
  DefinitionParameterProtocol_one: 'Definition parameter protocol',
  DefinitionParameterProtocol_other: 'Definition parameter protocols',
  DefinitionParameterSet_one: 'Definition parameter preset',
  DefinitionParameterSet_other: 'Definition parameter presets',
  DefinitionParameter_one: 'Definition parameter',
  DefinitionParameter_other: 'Definition parameters',
  DefinitionProtocol_one: 'Definition protocol',
  DefinitionProtocol_other: 'Definition protocols',
  DefinitionUnit_one: 'Definition unit',
  DefinitionUnit_other: 'Definition units',
  Definition_one: 'Definition',
  Definition_other: 'Definitions',
  DefintionPrameter_one: 'Definition parameter',
  DefintionPrameter_other: 'Definition parameter',
  Delete: 'Delete',
  DeleteAttachment: 'Delete',
  DeleteBackupFiles: 'Delete backup files',
  DeleteBackupFilesConfirmation: 'Are you sure you want to delete all backup files?',
  DeleteBeamQualityDisabledReasonTooltipMsg:
    'The beam quality cannot be deleted because the owning medical system is in use.',
  DeleteButtonTooltip: 'Delete',
  DeleteComment: 'Delete comment',
  DeleteCommentQuestion: 'Are you sure you want to delete this comment?',
  DeleteConfigurationInfoMsg:
    'When the task item is deleted, all related work items are automatically removed from all work lists within job configurations in which they appear. \nAs a consequence, the work items are removed from scheduled jobs. The work items are also deleted from jobs already in progress—however, only if they have not yet been processed. Completed jobs remain unaffected.\n\n{{hint}}',
  DeleteDefinitionParameterSetDisabledReasonTooltipMsg:
    'The definition parameter preset cannot be removed because it is in use or predefined.',
  DeleteEntityConfirmationHint: 'This action cannot be undone.',
  DeleteEntityConfirmationMsg: 'Are you sure you want to delete this entity?',
  DeleteEnumerationItem: 'Delete',
  DeleteEvaluationGeometry: 'Delete',
  DeleteEvaluationGeometryDisabledReasonTooltipMsg:
    'The owning definition is used or predefined. The quantity specifier cannot be deleted.',
  DeleteJobConfigurationInfoMsg:
    'Deleting this {{entityName}} has the following effects: {{effects}}',
  DeleteJobOccurrenceHintMsg:
    'When deleting the job, existing results will remain available in the result management and can still be viewed. However, generating new reports will no longer be possible.\n\n{{hint}}',
  DeleteSetupGeometry: 'Delete',
  Deleted: 'Deleted',
  DeletedComment: 'Deleted comment',
  DeletedEnumeration: 'Deleted enumeration',
  DeletedUnit: 'Deleted unit',
  DeliveryDate: 'Delivery date',
  Description: 'Description',
  DeselectAllPermissions: 'Deselect all permissions',
  Details: 'Details',
  DetectorChamberMap: 'Detector chamber map',
  DetectorDeviceIdentEnum: { STARCHECKMULTIRANGE: 'STARCHECK multi range' },
  DeviceInformation: 'Device information',
  DeviceInformationBatteryVersion: 'Battery version',
  DeviceInformationDeviceVersion: 'Device version',
  DeviceInformationFirmwareVersion: 'Firmware version',
  DeviceInformationHardwareVersion: 'Hardware version',
  DeviceInformationInterfaceBoardVersion: 'Interface board version',
  DeviceInformationMainboardVersion: 'Mainboard version',
  DeviceInformationOfflineMsg: 'Device information is displayed as soon as the device is online.',
  DeviceInformationUnicheckVersion: 'UNICHECK version',
  DeviceIsOffline: '{{deviceName}} is offline.',
  DeviceSerialNumber: 'Device serial number',
  DeviceStatusIslandActiveDevices: '{{count}} active devices',
  DeviceStatusIslandConnected: 'Connected',
  DeviceStatusIslandConnectedTo: 'Connected to {{names}}',
  DeviceStatusIslandReference: 'REF: {{value}}',
  DeviceStatusIslandSerial: 'SN: {{value}}',
  DeviceStatusIslandTitle: 'Device status',
  DeviceStatusIslandViewDetails: 'View details for {{value}}',
  DeviceWillBeDisabledMsg:
    'The device will be disabled and cannot be used for performing measurements.',
  DicomErrorMessage: {
    InstanceNotSaved: 'DICOM instance {{0}} cannot be saved due to the following exception: {{1}}',
    RtPlanIsNotImportable: {
      DynamicField:
        "The RTPlan cannot be imported because the field '{{0}}' is not static for all beams.",
      WrongDosimeterUnit:
        'The RTPlan cannot be imported because the primary dosimeter unit is {{0}} but should be {{1}}.',
    },
  },
  DicomMachineName: 'DICOM machine name',
  DicomMessage: {
    InstanceAlreadyPresent: 'DICOM instance {{0}} is already present',
    InstanceSaved: 'DICOM instance {{0}} successfully saved',
  },
  DicomScuStoreMessage: {
    InstanceStoredWithSuccess: "The DICOM stream with SOP instance UID '{{0}}' has been saved",
  },
  DicomTreatmentMachineName: 'DICOM treatment machine name',
  Disable: 'Disable',
  DisableAccountMsg:
    'If you disable this user account, the user will be automatically logged out if they are currently signed in.\n\nPlease note: Even in a disabled state, this user can still be assigned to jobs.',
  DisableEntityInfoMsg: 'Disabling the {{entityName}} will affect the following entities:',
  DisableJobConfigurationInfoMsg:
    'If you disable the {{entityName}}, all related jobs can no longer be executed.\n\nOnce you re-enable the {{entityName}}, all related jobs can be started or re-opened again.',
  DisableMedicalSystemInfoMsg:
    'If you disable the {{entityName}}, all related jobs can no longer be started or reopened. Jobs in State"In execution" can still be performed. \n\nOnce you re-enable the {{entityName}}, these jobs will be available again.',
  DisableQaEquipmentInfoMsg:
    'If you disable the {{entityName}}, all related work items can no longer be processed.\n\nOnce you re-enable the {{entityName}}, these work items will be available again.',
  DisableTaskItemInfoMsg:
    'If you disable the {{entityName}}, all related work items that haven\'t been started yet will be removed from jobs.\n\nOnce you re-enable the {{entityName}}, the affected work items will automatically be restored in jobs with state "New" or "Paused".',
  Disabled: 'Disabled',
  Discard: 'Discard',
  DisplayedDecimals: 'Displayed decimals',
  DomainName: 'Domain name',
  DoseRatesForStaticBeams: 'Dose rate',
  DosimetryAndQaEquipment: 'QA equipment',
  DosimetryAndQaEquipmentDescriptionMsg: 'Manage QA equipment.',
  DosimetryAndQaEquipmentEntityLowerCased_one: 'QA equipment',
  DosimetryAndQaEquipmentEntityLowerCased_other: 'QA equipment',
  DosimetryAndQaEquipmentEntity_one: 'QA equipment',
  DosimetryAndQaEquipmentEntity_other: 'QA equipment',
  DosimetryAndQaSetups: 'QA equipment setups',
  DownloadCsv: 'Download CSV file',
  DownloadOrPrintReport: 'Download / print report',
  DpinDisabledReasonTooltipMsg:
    'The DPIN cannot be changed for devices that are in use or have already been registered.',
  DpinTooltipMsg: 'The DPIN (= "Device-PIN") is located on the rear side of the device.',
  Due: 'Due',
  DuplicateSuffix: 'copy',
  DuplicateTargetArea: 'Duplicate target area',
  DuplicatedTargetAreaNotification:
    'Target area has been duplicated. Please check your setup parameters and settings for compatibility with the new medical system.',
  Edit: 'Edit',
  EditBeamQuality: 'Edit beam quality',
  EditBeamQualityRemoveDosrateNotAllowedMsg:
    'For medical systems in use, dose rates can only be added. Missing dose rates are: {{rates}}',
  EditDefinition: 'Edit definition',
  EditDefinitionParameterSet: 'Edit definition parameter preset',
  EditDefinitionParameterSetDisabledReasonTooltipMsg:
    'The definition parameter preset cannot be edited because it is predefined.',
  EditDefinitionTooltipMsg:
    'To edit this definition, you must delete all referenced definition parameter presets first.',
  EditEvaluationQuantity: 'Edit evaluation quantity',
  EditPredefinedDefinitionTooltipMsg:
    'This definition is not allowed to be edited because it is predefined.',
  EditQuantity: 'Edit quantity',
  EditedSinceBy: 'since {{since}} by {{user}}',
  ElectronBeamQuality: 'Electron beam quality',
  ElectronBeamQualityDoseRates: 'Electrons',
  Email: 'Email',
  EmailRepeated: 'Email repeated',
  EmailSettings: 'Email settings',
  EmailSettingsErrorMsg: 'Something went wrong. Please check the settings and try again.',
  EmailSettingsExplanationMsg:
    'The UNICHECK Software needs to send emails to users, e.g., for activation the user account, for resetting the password, etc. Therefore, you need to configure the email settings.',
  EmailSettingsValid: 'Email settings valid.',
  Emails: {
    SecurityCodeSubject: 'Security Code',
    InvitationTemplate: {
      ButtonText: 'Activate account',
      HeadLine: 'Hello',
      Message:
        'A UNICHECK Software account has been created for you.<br />Click the button below to activate your account.',
      Title: 'Activate account',
      LinkExpirationMsg: 'This link will be valid until',
    },
    LdapImportedTemplate: {
      ButtonText: 'Go to UNICHECK Software',
      HeadLine: 'Dear {{name}}',
      Message:
        'You have been added as a user to your central user management system via our secure LDAP connection.',
      ThankYouText: 'Best regards from the UNICHECK Software team',
      Title: 'Welcome to UNICHECK Software',
    },
    ResetPasswordTemplate: {
      ButtonText: 'Reset password',
      HeadLine: 'Hello',
      Message:
        'A password change has been requested for your account.<br />Click the button below to reset your password.',
      LinkExpirationMsg:
        'This link is valid for 20 minutes and can be used only once.<br />It expires automatically if you do not use it.<br />If you have not requested a new password, you can simply delete this email.',
      Title: 'Reset password',
    },
    Templates: { CopyRights: 'PTW Dosimetry<br>The Dosimetry Company' },
    AlternativeToButtonClickMsg:
      'Alternatively, copy the following URL into the address bar of your browser:',
    PoweredByPtwMsg: 'Powered by PTW - The Dosimetry Company',
    FooterPtwAddress: 'PTW Freiburg GmbH | Lörracher Str. 7 | 79115 Freiburg | Germany',
    FooterPtwWebsiteAndEmail: 'www.ptwdosimetry.com | info@ptwdosimetry.com',
    DeviceLicenseExpiryTemplate: {
      Title: 'UNICHECK addon license will expire soon',
      DeviceWillBeDisabledMsg:
        'The UNICHECK device will be disabled upon expiry and will no longer be usable for measurements.',
    },
    ApplicationLicenseExpiryTemplate: {
      Title: 'Your license will expire soon',
      AccessToSoftwareWillBeBlockedMsg:
        'Please save all required quality assurance data, as access to the UNICHECK Software will be completely blocked after the license expires.',
    },
  },
  Enable: 'Enable',
  EnableSsl: 'Enable TLS',
  Enabled: 'Enabled',
  End: 'End',
  EndDate: 'End date',
  EndTime: 'End time',
  EndUserLicenseAgreement: 'End User License Agreement (EULA)',
  EndUserLicenseAgreementUrl:
    'https://www.ptwdosimetry.com/fileadmin/user_upload/Downloads/Terms_and_Conditions/PTW_EULA_08_2023_en.pdf',
  Energy: 'Energy',
  EnterAValidPortNumber: 'Please enter a valid port number (0-65535)',
  EnterAtLeastXCharacters: 'Enter at least {{amount}} characters',
  EnterEmailForResetPasswordInstructionsMsg:
    'Enter your email address and we will send you an email with instructions to reset your password.',
  EnterGroupName: 'Enter group name',
  EntityAdded: '{{name}} | {{iuid}} added',
  EntityIsInEditingState:
    'This entity is currently being edited by another user and cannot be modified right now.',
  EntityReferencesInfoMsg: 'This entity is referenced in the following areas:',
  EntityType: 'Entity type',
  Entity_one: 'Entity',
  Entity_other: 'Entities',
  Enumerable: 'enumerable',
  EnumerationDescriptionLabelEnum: {
    TreatmentDeliveryTypeMsg: 'treatment delivery type',
    RadiationTypeLinacMsg:
      'The "Radiation type" describes the type of ionizing radiation used for clinical diagnostic or therapeutic applications. The radiation can either be comprised of emitted particles or electromagnetic waves.',
    PrimaryFluenceShapingMsg:
      'The "Primary fluence shaping" defines whether the beam is characterized by a non-standard fluence shaping (e.g., FFF or SRS).',
    HighDoseTechniqueTypeMsg:
      'The "High dose technique" refers to a treatment technique delivering a beam with high dose rates.',
    RadiationFieldSymmetryMsg:
      'The "Radiation field symmetry" describes the position of the radiation field in relation to the central beam axis.',
    RadiationFieldShapeMsg:
      'The "Radiation field shape" describes the form of a radiation field collimated by either the jaws and/or a multi-leaf-collimator (MLC).',
    JawAsymmetryMsg: 'jaw asymmetry',
    MlcMsg: 'MLC',
    ApplicatorTypeMsg: 'applicator type',
    WedgeTypeMsg: 'wedge type',
    WedgeOrientationMsg: 'wedge orientation',
    ImagePlaneMsg: 'image plane',
    ImagingTypeMsg: 'image type',
    BeamTypeMsg: 'beam type',
    Orientation3dMsg:
      'The "Detector orientation" refers to the orientation of a radiation detector (e.g,. an array detector) in relation to the X-,Y- or Z-axis.',
    IsocenterAlignmentMsg:
      'The "Isocenter alignment" describes the general procedure for aligning an object (e.g., a QA device) to the isocenter. In addition to a manual alignment, there are various approaches for automatic alignment.',
    ManualAlignmentMethodMsg:
      'The "Manual alignment method" describes the procedure for manual positioning of an object (e.g., a QA device) at the isocenter. Various reference points can be used for orientation, such as the laser isocenter.',
  },
  EnumerationEvaluationHint: 'Assign an evaluation result to an enumeration item.',
  EnumerationItem_one: 'Enumeration item',
  EnumerationItem_other: 'Enumeration items',
  EnumerationNameLabelEnum: {
    IsocenterAlignment: 'Isocenter alignment',
    ManualAlignmentMethod: 'Manual alignment method',
    EvaluationType_one: 'Evaluation type',
    EvaluationType_other: 'Evaluation types',
    BeamType: 'Beam type',
    TreatmentDeliveryType: 'Treatment delivery type',
    RadiationTypeLinac: 'Radiation type',
    PrimaryFluenceShaping: 'Primary fluence shaping',
    HighDoseTechniqueType: 'High dose technique type',
    RadiationFieldSymmetry: 'Radiation field symmetry',
    RadiationFieldShape: 'Radiation field shape',
    JawAsymmetry: 'Jaw asymmetry',
    Mlc: 'MLC',
    ApplicatorType: 'Applicator type',
    WedgeType: 'Wedge type',
    WedgeOrientation: 'Wedge orientation',
    ImagePlane: 'Image plane',
    ImagingType: 'Imaging type',
    IndexSystem: 'Index system',
    Orientation3d: 'Detector orientation',
  },
  EnumerationNotUsedInEvaluationsMsg: 'This enumeration is not used in evaluations.',
  EnumerationNotUsedInSetupsMsg: 'This enumeration is not used in setups.',
  EnumerationOptionLabelEnum: {
    Manual: 'Manual',
    MatchWithLightFieldCrossHairAndOdi: 'Match with light field crosshair and ODI',
    MatchWithRoomLasers: 'Match with room lasers',
    Symmetrical: 'Symmetrical',
    Asymmetrical: 'Asymmetrical',
    FFF: 'FFF',
    SRS: 'SRS',
    None: 'None',
    Treatment: 'Normal patient treatment',
    OpenPortfilm: 'Portal image acquisition with open field',
    TrmtPortfilm: 'Portal image acquisition with treatment port',
    Continuation: 'Continuation of interrupted treatment',
    Setup: 'No treatment beam was applied for this RT Beam',
    Static: 'Static',
    Dynamic: 'Dynamic',
    Photon: 'Photon',
    Electron: 'Electron',
    HDR: 'HDR',
    TBI: 'TBI',
    none: 'None',
    Rectangular: 'Rectangular',
    Circular: 'Circular',
    Irregular: 'Irregular',
    Yes: 'Yes',
    No: 'No',
    ElectronSquare: 'Square electron applicator',
    ElectronRectangular: 'Rectangular electron applicator',
    ElectronCircular: 'Circular electron applicator',
    ElectronShort: 'Short electron applicator',
    ElectronOpen: 'Open (dummy) electron applicator',
    PhotonSquare: 'Square photon applicator',
    PhotonRectangular: 'Rectangular photon applicator',
    PhotonCircular: 'Circular photon applicator',
    Intraoperative: 'Intraoperative (custom) applicator',
    Stereotactic: 'Stereotactic applicator (deprecated)',
    Standard: 'Standard',
    Motorized: 'Motorized',
    IN: 'IN',
    OUT: 'OUT',
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
    Normal: 'Normal',
    NonNormal: 'Non-normal',
    kVPlanar: 'kV planar',
    kVCBCT: 'kV-CBCT',
    MVPlanar: 'MV planar',
    ZeroDegree: '0°',
    NinetyDegree: '90°',
    HundredEightyDegree: '180°',
    TwoHundredSeventyDegree: '270°',
    Verification: 'Treatment used for QA',
    Elekta: 'Elekta',
    Varian: 'Varian',
    OtherIndexingSystem: 'Other indexing system',
    ZeroZeroZeroDegree: '(0°, 0°, 0°)',
    ZeroNinetyZeroDegree: '(0°, 90°, 0°)',
    ZeroTwoHundredSeventyZeroDegree: '(0°, 270°, 0°)',
    ZeroOneHundredEightyZeroDegree: '(0°, 180°, 0°)\n',
  },
  Enumeration_one: 'Enumeration',
  Enumeration_other: 'Enumerations',
  Enumerations: { Label: 'Enumerations' },
  EnvironmentalConditions: 'Environmental conditions',
  Error: {
    Cause: {
      DDC_Config: 'The measurement unit is not responding correctly. (Code: {{code}})',
      TemperatureSensor: 'The temperature sensor is not working properly. (Code: {{code}})',
      AirpressureSensor: 'The air pressure sensor is not working properly. (Code: {{code}})',
      FIFO_corr: 'A memory error was detected and automatically corrected. (Code: {{code}})',
      FIFO_uncorr: 'A memory error was detected and could not be corrected. (Code: {{code}})',
      FIFO_Underrun: 'The memory is not working properly. (Code: {{code}})',
      FIFO_Overrun: 'The memory is temporarily not working properly. (Code: {{code}})',
      HV: 'The high voltage regulation  is not working properly. (Code: {{code}})',
      HV_Undervoltage: 'The high voltage is lower than the expected value. (Code: {{code}})',
      HV_Overvoltage: 'The high voltage is higher than the expected value. (Code: {{code}})',
      Overload: 'The dose / dose rate exceeded the measuring range. (Code: {{code}})',
      Crc: 'Checksum error during measurement occurred. (Code: {{code}})',
      Device_Integrity: 'System test at startup failed. (Code: {{code}})',
      Mainboard_Config: 'Reading mainboard configuration failed. (Code: {{code}})',
      HV_Calibration_Config:
        'Reading high voltage calibration information failed. (Code: {{code}})',
      Radiologic_Config: 'Reading calibration information failed. (Code: {{code}})',
      Battery_Status: 'Reading battery information failed. (Code: {{code}})',
      IotBoard_Config: 'Reading IoT Board configuration failed. (Code: {{code}}',
      InterfaceBoard_Config: 'Reading interface board configuration failed. (Code: {{code}})',
      Hostname_Config: 'Reading hostname configuration failed. (Code: {{code}})',
      Setting_Config: 'Reading calibration configuration failed. (Code: {{code}})',
      IotIdentity_Config: 'Reading IoT Identity configuration failed. (Code: {{code}})',
      IotIdentityCache: 'Reading IoT Identity cache failed. (Code: {{code}})',
      HvReturnCalibration_Config:
        'Reading high voltage measurement calibration information failed. (Code: {{code}})',
      Error_General: 'Unspecified error occurred. (Code: {{code}})',
      IoTDevice_Unavailable: 'The device is off or unavailable. (Code: {{code}})',
      IoTDevice_InUse: 'The device is currently in use. (Code: {{code}})',
      MeasurementStart_ServiceNotReady:
        'The device cannot be triggered to run a measurement. (Code: {{code}})',
      MeasurementRunning_NoBeamDetected:
        'No beam detected in the past 5 minutes. Measurement stream stopped to save battery. (Code: {{code}})',
      MeasurementRunning_StreamingError:
        'The data stream from the device was interrupted. (Code: {{code}})',
      ZeroSignalTooHigh:
        'Irradiation is detected within the first second of the measurement. (Code: {{code}})',
      BeamOnDuringOffsetMeasurement:
        'Irradiation detected during zero-offset measurement. (Code: {{code}})',
      Analysis_TemperatureDeviation: 'Deviation in temperature sensors detected. (Code: {{code}})',
      Analysis_TemperatureOutOfLimit:
        'The measured air temperature is out of the expected range (between 5°C and 45°C). (Code: {{code}})',
      Analysis_AirpressureOutOfLimit:
        'The measured air pressure is out of the expected range (between 540 hPa and 1100 hPa). (Code: {{code}})',
      Analysis_CalibrationCorrupted: 'The calibration information is incorrect. (Code: {{code}})',
      Analysis_MathError: 'Analysis result could not be calculated. (Code: {{code}})',
      ConnectionUsb: 'Internal communication failed. (Code: {{code}})',
      NotCalibrated: 'Device is not calibrated. (Code: {{code}})',
      VersionsFirmware: 'Internal communication failed. (Code: {{code}})',
      DeviceState: 'Internal communication failed. (Code: {{code}})',
      MeasurementRunning_NoBeamOffDetected: 'Irradiation duration limit exceeded. (Code: {{code}})',
      Communication_MeasurementService: 'The connection to the device is broken. (Code: {{code}})',
      Analysis_InvalidSetupParameter: 'Analysis result could not be calculated. (Code: {{code}})',
      Fabric: 'The measurement unit is not responding correctly. (Code: {{code}})',
      Fabric_Config: 'The measurement unit is not responding correctly. (Code: {{code}})',
      Firmware_Crc: 'The measurement unit is not responding correctly. (Code: {{code}})',
      IoTDevice_DefectDetected: 'Defect detected on the device. (Code: {{code}})',
      Integrator_Corr:
        'An integrator memory error was detected and  automatically corrected. (Code: {{code}})',
      Integrator_Uncorr:
        'An integrator memory error was detected and could not be corrected. (Code: {{code}})',
      Analysis_General: 'A general analysis error occurred. (Code: {{code}})',
    },
    Message: {
      DDC_Config: 'Hardware defect',
      TemperatureSensor: 'Temperature sensor defect',
      AirpressureSensor: 'Air pressure sensor defect',
      FIFO_corr: 'Memory error corrected',
      FIFO_uncorr: 'Memory error uncorrected',
      FIFO_Underrun: 'Memory defect',
      FIFO_Overrun: 'FIFO Overrun Error',
      HV: 'High voltage error',
      HV_Undervoltage: 'High voltage error',
      HV_Overvoltage: 'High voltage error',
      Overload: 'Overload',
      Crc: 'Checksum error',
      Mainboard_Config: 'Configuration error',
      Device_Integrity: 'System test failed',
      HV_Calibration_Config: 'Configuration defect',
      Radiologic_Config: 'Configuration defect',
      Battery_Status: 'Battery error',
      IotBoard_Config: 'Configuration error',
      InterfaceBoard_Config: 'Configuration error',
      Hostname_Config: 'Configuration error',
      Setting_Config: 'Configuration error',
      IotIdentity_Config: 'Configuration error',
      IotIdentityCache: 'Configuration error',
      HvReturnCalibration_Config: 'Configuration error',
      Error_General: 'Unspecified error',
      IoTDevice_Unavailable: 'Device not available',
      MeasurementRunning_StreamingError: 'Measurement data interrupted',
      IoTDevice_InUse: 'Device is in use',
      MeasurementStart_ServiceNotReady: 'Communication error',
      MeasurementRunning_NoBeamDetected: 'No beam detected',
      ZeroSignalTooHigh: 'Signal too high',
      BeamOnDuringOffsetMeasurement: 'Zero measurement failed',
      Analysis_TemperatureDeviation: 'Temperature deviation',
      Analysis_TemperatureOutOfLimit: 'Air temperature out of expected range',
      Analysis_AirpressureOutOfLimit: 'Air pressure out of expected range',
      Analysis_CalibrationCorrupted: 'Calibration information invalid',
      Analysis_MathError: 'Calculation error',
      ConnectionUsb: 'Hardware defect',
      NotCalibrated: 'Calibration error',
      VersionsFirmware: 'Communication error',
      DeviceState: 'Communication error',
      MeasurementRunning_NoBeamOffDetected: 'Measurement duration exceeded',
      Communication_MeasurementService: 'Communication error',
      Analysis_InvalidSetupParameter: 'Setup invalid',
      Fabric: 'Hardware defect',
      Fabric_Config: 'Hardware defect',
      Firmware_Crc: 'Hardware defect',
      IoTDevice_DefectDetected: 'Device is defective',
      Integrator_Corr: 'Memory error corrected',
      Integrator_Uncorr: 'Memory error uncorrected',
      Analysis_General: 'Analysis error',
    },
    Remedy: {
      DDC_Config: 'Please contact PTW support for verification or repair.',
      TemperatureSensor: 'Please contact PTW support for verification or repair.',
      AirpressureSensor: 'Please contact PTW support for verification or repair.',
      FIFO_corr: 'If the information persists, contact PTW support.',
      FIFO_uncorr: 'If the error persists, contact PTW support.',
      FIFO_Underrun: 'Please contact PTW support for verification or repair.',
      FIFO_Overrun: 'If the warning persists, contact PTW support.',
      HV: 'Repeat the measurement. If the error persists, contact PTW support. The main board may have to be replaced.',
      HV_Undervoltage:
        'Repeat the measurement. If the error persists, contact PTW support. The main board may have to be replaced.',
      HV_Overvoltage:
        'Repeat  the measurement. If the error persists, contact PTW support. The main board may have to be replaced.',
      Overload:
        'Check the medical system setup parameters and repeat  the measurement. If the error persists, contact PTW support.',
      Crc: 'Repeat the measurement. If the error persists, contact PTW support.',
      Mainboard_Config: 'If the error persists, contact PTW support.',
      Device_Integrity: 'Please contact PTW support for verification or repair.',
      HV_Calibration_Config: 'Please contact PTW support for verification or repair.',
      Radiologic_Config: 'Please contact PTW support for verification or repair.',
      Battery_Status: 'If the error persists, contact PTW support.',
      IotBoard_Config: 'If the error persists, contact PTW support.',
      InterfaceBoard_Config: 'If the error persists, contact PTW support.',
      Hostname_Config: 'If the error persists, contact PTW support.',
      Setting_Config: 'If the error persists, contact PTW support.',
      IotIdentity_Config: 'If the error persists, contact PTW support.',
      IotIdentityCache: 'If the error persists, contact PTW support.',
      HvReturnCalibration_Config: 'If the error persists, contact PTW support.',
      Error_General: 'If the error persists, contact PTW support.',
      IoTDevice_Unavailable:
        'Check if the device is switched on, registered, enabled and connected to the network.',
      MeasurementRunning_StreamingError: 'Make sure the data connection is established and stable.',
      IoTDevice_InUse: 'Check if the device is not used already by another user.',
      MeasurementStart_ServiceNotReady:
        'Repeat the measurement. If the error persists, contact PTW support.',
      MeasurementRunning_NoBeamDetected: 'Repeat the measurement and start irradiation.',
      ZeroSignalTooHigh:
        'Stop irradiation and repeat the measurement.\nIf the error persists, contact PTW customer support.',
      BeamOnDuringOffsetMeasurement:
        'Stop irradiation and repeat the measurement. If the error persists, contact PTW support.\n',
      Analysis_TemperatureDeviation:
        'Wait a few minutes and repeat the measurement. If the error persists, contact PTW support.',
      Analysis_TemperatureOutOfLimit:
        'Wait a few minutes and repeat the measurement. If the error persists, contact PTW support.',
      Analysis_AirpressureOutOfLimit:
        'Wait a few minutes and repeat the measurement. If the error persists, contact PTW support.',
      Analysis_CalibrationCorrupted:
        'Update calibration in QA equipment detail view. If the error persists, contact PTW support.',
      Analysis_MathError:
        'Check the measurement setup and repeat the measurement. If the error persists, contact PTW support.',
      ConnectionUsb: 'Please contact PTW support for verification or repair.',
      NotCalibrated: 'If the error persists, contact PTW support.',
      VersionsFirmware: 'If the error persists, contact PTW support.',
      DeviceState: 'If the error persists, contact PTW support.',
      MeasurementRunning_NoBeamOffDetected:
        'Stop irradiation and repeat the measurement. If the error persists, contact PTW support.',
      Communication_MeasurementService:
        'Ensure that all services are running. If the error persists, contact PTW support.',
      Analysis_InvalidSetupParameter:
        'Check the measurement setup and repeat the measurement. If the error persists, contact PTW support.\n',
      Fabric: 'Please contact PTW support for verification or repair.',
      Fabric_Config: 'Please contact PTW support for verification or repair.',
      Firmware_Crc: 'Please contact PTW support for verification or repair.',
      IoTDevice_DefectDetected: 'Please contact PTW support for verification or repair.',
      Integrator_Corr: 'If the information persists, contact PTW support.',
      Integrator_Uncorr: 'If the error persists, contact PTW support.',
      Analysis_General: 'Repeat the measurement. If the error persists, contact PTW support.',
    },
    MeasurementAborted: 'Measurement has been aborted due to {{SeverityType}}',
    Category: {
      Unauthorized: {
        title: 'Unauthorized',
        message: 'You need to sign in to execute this operation.',
      },
      BadRequest: { title: 'Bad request', message: 'The submitted data is invalid or incomplete.' },
      SemanticError: {
        title: 'Unable to complete request',
        message: 'We found an issue with the submitted data.',
      },
      NotFound: { title: 'Resource not found', message: 'The requested resource does not exist.' },
      ServerError: {
        title: 'Server error',
        message: 'Something has gone wrong on our side. Please try again later.',
      },
      Other: { title: 'Unexpected error', message: 'An unexpected error has occurred.' },
      Forbidden: { title: 'Forbidden', message: 'The operation is forbidden.' },
    },
  },
  ErrorStrategyConst: 'Allowed value: {{allowedValue}}',
  ErrorStrategyType: 'This field requires a valid {{type}}.',
  ErrorTitle: 'Error',
  ErrorsInSection: 'Some fields contain errors. Please review and correct them.',
  EvaluationField: {
    AreaFlatness: 'Area flatness',
    AreaSymmetry: 'Area symmetry',
    BeamDoseOutput: 'Beam dose output',
    NominalPhotonBeamEnergy: 'Nominal photon beam energy',
    BeamProfileConstancy: 'Beam profile constancy',
    ElectronBeamArea: 'Electron beam area',
    ElectronBeamProfile: 'Electron beam profile',
    FieldEdgePosition: 'Field edge position',
    Flatness: 'Flatness',
    PenumbraWidth: 'Penumbra width',
    PhotonBeamArea: 'Photon beam area',
    PhotonBeamProfile: 'Photon beam profile',
    PhotonBeamProfileFlatness: 'Photon beam profile flatness',
    PhotonBeamProfileSymmetry: 'Photon beam profile symmetry',
    RadiationFieldSize: 'Radiation field',
    Symmetry: 'Symmetry',
    X1: 'X1',
    X2: 'X2',
    XAxis: 'X-axis',
    XProfile: 'X-profile',
    Y1: 'Y1',
    Y2: 'Y2',
    YAxis: 'Y-axis',
    YProfile: 'Y-profile',
    NominalElectronBeamEnergy: 'Nominal electron beam energy',
    BeamQualityFactor: 'Beam quality factor',
    BeamNumber: 'Beam number',
    BeamName: 'Beam name',
    BeamDescription: 'Beam description',
    BlockName: 'Block name',
    ImagingDevSpecAcqParameter: 'Imaging device specific acquisition parameter',
    ImagingTemplate: 'Imaging template',
    ImagingInstructions: 'Imaging instruction',
    IndexingInstruction: 'Indexing instruction',
    OrientationInstruction: 'Orientation instruction',
    AlignmentInstruction: 'Alignment instruction',
    AdditionalSetupInstruction: 'Additional setup instruction',
  },
  EvaluationGeometry_one: 'Quantity specifier',
  EvaluationGeometry_other: 'Quantity specifiers',
  EvaluationLabel: { PhotonWff: 'Photons', PhotonFff: 'Photons FFF', Electron: 'Electrons' },
  EvaluationLimitsHint:
    'Enter the limits to be applied during the job execution to evaluate the measurement results.',
  EvaluationQuantityOrEnumeration: 'Quantity or enumeration',
  EvaluationQuantity_one: 'Evaluation quantity',
  EvaluationQuantity_other: 'Evaluation quantities',
  EvaluationResult: 'Evaluation result',
  EvaluationStateEnum: {
    Failed: 'Failed',
    Passed: 'Passed',
    Warning: 'Warning',
    WithoutEvaluation: 'Without evaluation',
    Open: 'Open',
    Skipped: 'Skipped',
  },
  EvaluationTypeEnum: {
    AbsoluteValue: 'Absolute value',
    AbsoluteDifference: 'Absolute difference',
    Ratio: 'Ratio',
    RelativeDifference: 'Relative difference',
  },
  EvaluationType_one: 'Evaluation type',
  EvaluationType_other: 'Evaluation types',
  EvaluationUnit_one: 'Evaluation unit',
  EvaluationUnit_other: 'Evaluation units',
  Evaluation_one: 'Evaluation',
  Evaluation_other: 'Evaluations',
  Every: 'Every',
  Example: 'Example',
  Exceptions: {
    MigrationOfTenantDatabaseFailed: 'An error occurred during migration of tenant database:',
    CsoPortal: {
      WrongDpin: 'DPIN is not assigned to this equipment.',
      AuthenticationFailed: 'Failed to authenticate to myPTW.',
      Forbidden: 'Access to myPTW is forbidden.',
      InternalError: 'An internal error occurred inside myPTW. Please try again later.',
      NotFound:
        'No equipment with this serial number is assigned to your myPTW account (Company ID). [{{masterDeviceId}}]',
      PtwUserFriendlyException: 'An unexpected error occurred. {{0}}',
      RequestTimeOut: 'The request to myPTW timed out.',
      DeviceAlreadyRegisteredToThisIpin: 'The device is already registered to this installation.',
      DeviceAlreadyRegisteredToAnotherIpin:
        'Device already registered to another installation, please contact PTW support!',
      DeviceRegistrationWithSerialNumberIsNotSupported:
        'The device type does not support registration with serial number!',
      DeviceNotFoundOnIotHubMsg: 'Could not find the device on IoTHub!',
      DeviceCloudSetupFailedMsg: 'Failed to set up the device on PTW Cloud!',
      NoConnectionMsg: 'The connection to the PTW Cloud services could not be established.',
      UpdateAgentNotInstalledMsg: 'Update agent is not installed on your PtwEdge server!',
      DeplyomentSetNotActiveMsg: 'This version of the software is not active anymore!',
      UpdateToVersionNotValid: 'Update to the requested version is not valid!',
      NoUpdateUpgradeIsAvailableMsg: 'Update/Upgrade not available. You are on the latest version!',
      DeviceNotCalibratableMsg: 'This device does not support calibration!',
      DeviceNotRegistrableMsg: 'This device does not support registration!',
    },
    DemoDataSetsImportFailed: 'Import script failed!',
    AdminRoleCannotRemoveFromAdminUser:
      'Administrator role cannot be removed from administrator user.',
    AlreadyRegisteredEmailMsg: 'This email address is already registered with a user account.',
    AMeasurementDateWasNotRecognizedAsAValidDateAndTimeFormat:
      'A measurement date was not recognized as a valid date and time format.',
    ApplicationNotActivated:
      'Your installation is not active yet! You need to activate it in myPTW!',
    AppPermissionDoesNotExist: 'App permission does not exist.',
    AppSettingDoesNotExist: 'App setting {{SettingsName}} does not exist.',
    ByteValuesCanNotBeConvertedToDoubles: 'Byte values cannot be converted to doubles.',
    ByteValuesCanNotBeConvertedToFloats: 'Byte values cannot be converted to floats.',
    CouldNotGetUserId: 'Failed to get user ID',
    CurrentUserDidNotLoginToTheApplication: 'You have been automatically signed out.',
    Database: {
      AlreadyExistsMsg: 'Database already exists! Please use a new one.',
      ConcurrencyException:
        'The entity that you are trying to update has already been updated by another user!',
    },
    DeviceNotRegistered: 'Device with this ID {{0}} is not registered.',
    DeviceWithIdNotFound: 'Device with this ID cannot be found.',
    Dicom: {
      FileNotFound: "The DICOM file with the ID '{{0}}' was not found",
      NotFoundAValidLocalScu: 'Valid AE Title for the local SCU was not found.',
      RemoteScpHasNotValidParameters: 'Remote SCP contains some invalid parameters.',
      RemoteScpNotEnabled:
        "The selected remote SCP '{{0}}' is not enabled to execute the requested action.",
      RequiredParameterMissing: "The required parameter '{{0}}' is missing.",
      RtsetupAlreadyPresent:
        'A treatment machine setup with SOP instance UID {{0}} is already present.',
      ScuNotEnabled: "The SCU '{{0}}' is not enabled to execute the requested action.",
    },
    DicomRtPlanIsNotImportable: {
      NoValidBeams: 'The RT Plan cannot be imported because no valid beam descriptions were found.',
      NoValidFile: 'No valid DICOM object could be read.',
    },
    DicomScuStoreErrorMessage: {
      InstanceIsNotDicom: 'The content of the stream does not appear to be of the DICOM type.',
    },
    DicomValidationAetitleMessage: {
      ContainsControlChars: 'AE Title name contains invalid control character.',
      ContainsOnlySpaceChars: 'AE Title name must not consist only of spaces.',
      LengthExceed: 'AE Title name exceeds maximum length of 16 characters.',
    },
    EmailTemplates: {
      InvalidTEnum: '{{0}} is not a valid TEnum!',
      ParseFailed: 'Cannot parse the source template!',
    },
    EmptyLicenseToken: 'Empty license',
    EntityDoesNotExist: 'Entity does not exist.',
    ErrorOnlySoftDeletedCanHardDelete:
      "Only objects that have already been deleted ('Soft Delete') can be hard (physically) deleted.",
    Failed: 'Failed',
    FeatureDoesNotExist: 'FeatureDoesNotExist',
    FileEmptyError: 'File empty',
    FileSizeLimitError: 'File size limit exceeded',
    ImportXMLFileIsNotAValidImportXML: 'Import XML file is not a valid import XML.',
    ImportXMLHasNoVersionInformation: 'Import XML has no version information.',
    Install_InvalidCompanyId:
      'Cannot read Company ID from application settings. The license has probably not been imported!',
    Install_InvalidConnectionString:
      'ConnectionString is invalid. The Database/Initial Catalog keyword is missing',
    Install_InvalidIpin:
      'Cannot read IPIN from application settings. The license has probably not been imported!',
    Install_NoConnection: 'Unable to connect to the destination server!',
    InvalidDataTypeForAnalyzeValue: 'Invalid data type for analysis value.',
    InvalidEmailAddressOrPassword: 'Invalid email address or password',
    InvalidIPIN: 'Invalid IPIN',
    InvalidLicenseData: 'Invalid license',
    InvalidSecurityCode: 'Invalid security code!',
    InvalidUserNameOrPassword: 'Invalid user name or password.',
    IsInvalid: '{{0}} is invalid',
    IsLockoutEnabledHint:
      'User will be locked for {{0}} minutes after {{1}} failed login attempts.',
    LicenseCouldNotBeFindOnServer: 'LicenseCouldNotBeFindOnServer',
    LicenseIPINDoesNotMatchToTenantPin: 'License installation IPIN does not match Tenant',
    LicenseIsOlderThanCurrentlyUsed: 'License is older than currently used',
    LicensePortalConnectionFailure:
      'Connection to license portal failed. Please enable online or upload license file from disk',
    LinkedMedicalSystemDeleteError: 'Linked medical system cannot be deleted',
    LocationHierarchyParentNotExists: 'Parent of location does not exist',
    LocationHierarchyWrong: 'Wrong hierarchy of location and parent',
    MasterDeviceIdNotFound: 'The master device ID for this device cannot be found',
    MeasurementCouldNotBeImportedBecauseItDoesNotContainAdministrativeData:
      'Measurement could not be imported because it does not contain administrative data.',
    NoPermission: 'You do not have any permissions. Contact your administrator.',
    NoPlanByGivenPlanTypeId: 'No plan with specified plan type ID',
    NoTenantAvailableByLicenseIPIN: 'Tenant is not available by license IPIN',
    NoTenantOrUser: 'No tenant or user !',
    NotValid: 'Not valid',
    NoValidLicenseFound: 'No valid license was found!',
    OperationIsNotAllowed: 'Operation is not allowed!',
    PredicateCannotBeStartedAgain: 'Predicate cannot be started again.',
    ProfilePicture_Change_Error: 'Picture could not replaced.',
    ProfilePicture_Get_Error: 'Picture could not be uploaded.',
    ProtocolWithLinksCannotBeDeleted: 'A linked protocol cannot be deleted.',
    RefreshTokenIsNotValid: 'Refresh token is not valid!',
    RequiredField: '{{0}} This field is required.',
    ResourcesExceptionImportMissingTaskType: 'Resources.Exception_Import_MissingTaskType',
    RtSystemPrimaryLocation: 'There should be one primary location',
    SendSecurityCodeErrorMessage: 'Security code could not be sent!',
    SpecifiedSizeTooSmall: 'Specified size too small',
    TargetUserNotFoundProbablyDeleted: 'User could not be found.',
    TenantDoesNotExist: 'Tenant does not exist',
    TheAnalyzeValueHasAnInvalidFormat: 'The format of the analysis value is invalid.',
    TheAttachmentElementHasNoData: 'The attachment element has no data.',
    TheElementHasNoDataTypeReference: 'The element has no data type reference.',
    TheFileNameOfTheAttachmentIsInvalid: 'The file name of the attachment is invalid.',
    TheIdAttributeOfTheDataTypeIsMissingOrInvalid:
      'The \\id\\ attribute of the data type is missing or invalid."',
    TheIdAttributeOfTheMeasuringEquipmentIsMissingOrInvalid:
      'The \\id\\" attribute of the measuring equipment is missing or invalid."',
    TheIdAttributeOfTheMeasuringSoftwareIsMissingOrInvalid:
      'The \\id\\" attribute of the measuring software is missing or invalid."',
    TheIdAttributeOfTheTreatmentUnitIsMissingOrInvalid:
      'The \\id\\" attribute of the treatment machine is missing or invalid."',
    TheMeasuringEquipmentDefinitionIsInvalid: 'The measuring equipment definition is invalid.',
    TheMeasuringSoftwareDefinitionIsInvalid: 'The measuring software definition is invalid.',
    TheRadiationunitrefAttributeOfTheMeasurementIsMissingOrInvalid:
      'The \\radiation-unit-ref\\" attribute of the measurement is missing or invalid."',
    TheTreatmentUnitDefinitionIsInvalid: 'The treatment machine definition is invalid.',
    TimeoutPleaseTryAgain: 'Timeout! Please try again.',
    UnAuthorizedOperation: 'Unauthorized Operation',
    UnknownUserOrUserIdentifier: 'Unknown user or user identifier',
    UnsupportedLicenseVersion:
      'Unsupported license version {{0}}. Current version is: {{1}}. Please get a new license file.',
    UpdateSessionFailed: 'Could not reload the session information after configuration changes!',
    User0NotFound: 'User with ID {{email}} not found!',
    UserDoesNotExist: 'User does not exist',
    UserIsNotActive: 'User is inactive',
    UserStateIsActive: 'This user is active and cannot be deleted.',
    ValuesElementInMeasurementValuesIsMandatoryPositionsOrChamberNumbersWithoutValuesAreInvalid:
      'Values element in measurement values is mandatory. Positions or chamber numbers without values are invalid.',
    YouAreNotAuthorizedToPerformThisOperation: 'You are not authorized to perform this operation.',
    FormNotValid: 'This form contains errors. Review and correct them.',
    InternalServerError: 'Internal Server Error!',
    NotImplementedYet: 'This feature is not implemented yet...',
    PasswordComplexityViolation: 'Minimum 12 characters.',
    OneRoleLeftGrantingPermissions: 'At least one role must be enabled that grants certain rights.',
    CannotDisableRoleAssignedToYou: 'You cannot disable a role assigned to you.',
    NotSupportedFileFormatMsg: 'The selected file format is not supported.',
    Certificates: {
      ConnectionFailedMsg: 'Connection to IoTHub failed.',
      InvalidNotBeforeMsg: 'Certificate is not usable before {{notBefore}}',
      InvalidNotAfterMsg: 'Certificate has already expired on {{notAfter}}',
      NotMatchingCnMsg: 'CN field of the certificate does not match your FQDN.',
      WrongPassword: 'The password is not correct!',
      InvalidContent: 'Could not read the certificate file!',
    },
    YouNeedToRequestEditTokenFirstToEditEntity0:
      'You need to request an edit token first to edit the entity {{name}}.',
    '0NotAllowToEditPredefined1':
      '{{name}} is not allowed to be edited because it is a predefined {{reason}}.',
    MissingEditToken0: 'You need to request an edit token first to edit the entity {{name}}',
    ExistEditToken0: 'User already holds an edit token on the entity {{name}}',
    Preferences: { WrongPassword: 'Incorrect password.' },
    TimezoneNotFound: 'The specified time zone was not found.',
    DeviceAlreadyRegistered: 'The device is already registered to this installation.',
    SerialNumberNotUnique: 'This serial number already exists.',
    DeviceIsNotIotMsg: 'The device is not an IoT device!',
    CalibrationDataNotFoundMsg: 'Calibration data for {{MasterDeviceId}} not found!',
    CalibrationDataNotSupportedMsg: 'Device {MasterDeviceId} does not support calibration data!',
    NoNewCalibrationAvailableMsg: 'No new calibration is available for this device!',
    MinLengthEnumerationOptionsMsg: 'At least {{minLength}} options must be added to the list.',
    PtwEdgeUpdate: {
      AnUpdateIsAlreadyRunningMsg: 'Last update/upgrade to version {{version}} is still running!',
      NoUpdateIsRunningMsg: 'No update/upgrade is running!',
      EulaNotConfirmedByUserMsg:
        'Please read and confirm the End User License Agreement (EULA) to proceed.',
      BackupNotConfirmedByUserMsg:
        'Please confirm that you read the instruction and already made a backup of your system & database to proceed with the update/upgrade!',
    },
    ServerIsUnderMaintenanceMsg: 'The server is under maintenance now.',
    MaintenanceModeIsEnabledMsg: 'The server is under maintenance.',
    MaintenanceModeCouldNotDisableMsg:
      'Only the user {{user}} can deactivate the maintenance mode!',
    MeasurementIsRunningMsg_one: 'One measurement is still running!',
    MeasurementIsRunningMsg_other: '{{count}} measurements are still running!',
    InvalidUserPassword: 'User password is invalid!',
    MaintenanceModeNotEnabledMsg: 'Maintenance mode is deactivated.',
    UnitAbbreviationAlreadyExists: 'This unit already exists.',
    ThereAreSomeLoggedInUsersMsg_one: 'One user is still signed in.',
    ThereAreSomeLoggedInUsersMsg_other: '{{count}} users are still signed in.',
    InvalidCalibrationData: 'Calibration is invalid!',
    '0NotAllowedToDeletePredefined1':
      '{{name}} is not allowed to be deleted because it is a predefined {{reason}}.',
    YouNeedToRequestExecutionTokenFirstToEditEntity0:
      'In order to edit the job {{name}}, you must first request an execution token.',
    UnableToProcessInput: 'Unable to process input.',
    JobOccurrenceDeleteWrongState: 'You cannot delete a job with this state.',
    CannotDeleteLastUserWithRole: 'You cannot delete the last user with role {{role}}',
    TheFileIsNotAnImage: 'The file is not an image',
    InvalidValue: 'This value is invalid.',
    LocalUploadNotAllowedMsg: 'Local calibration upload is not allowed.',
    SerialNoInCalibrationDataDoesNotMatchWithSelectedDeviceMsg:
      'The serial number in the calibration file does not match with the selected QA equipment.',
    ModelInCalibrationDataDoesNotMatchWithSelectedDeviceMsg:
      'The device model in the calibration data file does not match with the selected QA equipment.',
    CommentTextOrFileRequired: 'The comment must have either a text or attachments',
    CouldNotDeserializeObject: 'Could not deserialize {{object}}',
    EvaluationNotEnabled: 'Evaluation usage is not enabled for entity {{EntityId}}',
  },
  ExceptionsCsoPortalDeviceAlreadyRegisteredToAnotherIpinRemedy:
    'Please check the serial number and retry. If you are sure that the serial number you entered is correct, the equipment must be de-registered from the other Software installation first.',
  ExceptionsCsoPortalNoConnectionRemedy:
    'You can try again or contact your local IT administrator to enable connection to PTW Cloud.',
  ExceptionsCsoPortalNotFoundRemedy:
    'Please check the serial number and retry. If you are sure that the serial number you entered is correct, you can send a request for assignment of the serial number to your Company ID.',
  ExceptionsCsoPortalWrongDpinRemedy:
    'Check serial number and / or DPIN and retry. If you are sure that the serial number and DPIN you entered are correct, contact PTW support.',
  ExecutionTime: 'Execution time',
  ExecutionTimeAndDay: 'Execution date and time',
  ExecutionTimeHint:
    'Define the start and end date/time of the first job. Based on this configuration and the specified recurrence pattern, the jobs will be created within the series period.',
  ExpandAll: 'Expand all',
  ExpandAllPermissionPanels: 'Expand all',
  ExpirationDate: 'Expiration date',
  ExpiresIn: 'Expires in',
  FieldIsRequired: 'This field is required.',
  FieldsCanNotBeEditedBecauseOfReferenceOfEntityMsg:
    'Some fields cannot be edited because the entity is already in use or predefined.',
  FileUploadNotFinishedMsg: 'The file upload is not finished yet.',
  Filter: 'Filter',
  FilterSearchFieldPlaceholder: 'Search or select filters',
  Finished: 'Finished',
  FirstName: 'First name',
  FloatingPoint: 'Floating-point number',
  ForgotPassword: 'Forgot password',
  FormatPKCS12AndFileTypePfx: 'The file must be in PKCS #12 format and the file type must be *.pfx',
  FrameworkModuleName: 'UNICHECK Framework',
  Frequency: 'Frequency',
  FrequencyType: {
    None: 'None',
    Daily: 'Daily',
    Weekly: 'Weekly',
    Monthly: 'Monthly',
    Yearly: 'Yearly',
  },
  From: 'From',
  FullManufacturerName: 'Physikalisch-Technische Werkstätten Dr. Pychlau GmbH',
  General: { Host: 'SMTP server', Port: 'SMTP port' },
  GeneralPlan: 'General plan',
  GeneralSettings: 'General settings',
  GeometryNameLabelEnum: {
    GeomX: 'X',
    GeomY: 'Y',
    GeomX1: 'X1',
    GeomX2: 'X2',
    GeomY1: 'Y1',
    GeomY2: 'Y2',
    GeomDiameter: 'Diameter',
    GeomXleft: 'X (left)',
    GeomXright: 'X (right)',
    GeomYleft: 'Y (left)',
    GeomYright: 'Y (right)',
  },
  GetToTaskItem: 'Open task item',
  GoToLicensePage: 'Go to license page',
  GoToSignIn: 'Go to sign in',
  GoToSignInNow: 'Go to sign in now',
  GroupNameAlreadyExistsMsg: 'This group name already exists.',
  Group_one: 'Group',
  Group_other: 'Groups',
  HandbookDownloadSelection: 'Select language:',
  HasPropertyEventLogs: 'Has Property Event Log Data',
  Help: 'Help',
  HideDefinitionSetParameters: 'Show less',
  HideLicenseDetails: 'Hide license details',
  HighDoseTechniqueType: 'High dose technique type',
  History: 'History',
  HistoryEvents: {
    AddedComment: 'Comment added',
    AddedEnumeration: 'Enumeration added',
    AddedEnumerationQuantity: 'Enumeration added',
    AddedUnit: 'Unit added',
    AddedUser: 'User account added',
    AdministrativeInformation: 'Administration',
    assignedRoles: 'Roles',
    attachments: 'Attachments',
    availableForUse: 'Available for use',
    DeletedComment: 'Comment deleted',
    DeletedEnumerationQuantity: 'Enumeration deleted',
    DeletedUnit: 'Unit deleted',
    description: 'Description',
    descriptionAttachments: 'Description attachments',
    emailAddress: 'Email address',
    EnumerationOptionEvaluations: 'Enumeration items',
    EnumerationOptionSetups: 'Setup items',
    EnumerationQuantity: 'Enumeration',
    firstName: 'First name',
    isUsageEnabledEvaluation: 'Use in evaluations',
    isUsageEnabledSetup: 'Use in setups',
    MedicalSystemScopeEvaluation: 'Medical systems',
    middleName: 'Middle name',
    mobileNumber: 'Mobile number',
    ModifiedComment: 'Modified comment',
    ModifiedEnumerationQuantity: 'Modified enumeration',
    ModifiedUnit: 'Modified unit',
    name: 'Name',
    phoneNumber: 'Phone number',
    QaEquipmentScopeEvaluation: 'QA equipment',
    stateOfUse: 'State of use',
    lastName: 'Last name',
    title: 'Title',
    UseInEvaluation: 'Use in evaluations',
    UseInSetup: 'Use in setups',
    ModifiedUser: 'User account modified',
    AddedProtocol: 'Protocol added',
    DeletedProtocol: 'Protocol deleted',
    ModifiedProtocol: 'Protocol modified',
    Abbreviation: 'Unit symbol',
    Description: 'Description',
    AssignedRoles: 'Roles',
    Attachments: 'Attachments',
    AvailableForUse: 'Available for use',
    DescriptionAttachments: 'Description attachments',
    EmailAddress: 'Email address',
    FirstName: 'First Name',
    IsUsageEnabledEvaluation: 'Use in evaluations',
    IsUsageEnabledSetup: 'Use in setups',
    MiddleName: 'Middle Name',
    MobileNumber: 'Mobile number',
    Name: 'Name',
    PhoneNumber: 'Phone Number',
    StateOfUse: 'State of use',
    LastName: 'Last name',
    Title: 'Title',
    IsUsageEnabled: 'Availability',
    MedicalSystemScopeSetup: 'Medical systems',
    QaEquipmentScopeSetup: 'QA equipment',
    IsAvailable: 'Availability',
    Roles: 'Roles',
    Publisher: 'Publisher',
    References: 'Reference',
    DateOfPublication: 'Publication date',
    State: 'State',
    FirstSignIn: 'First Sign In',
    AddedRole: 'Role added',
    Comment: 'Comment',
    AddedQuantity: 'Quantity added',
    DeletedQuantity: 'Quantity deleted',
    ModifiedQuantity: 'Quantity modified',
    AddedQaEquipment: 'QA equipment added',
    SerialNumber: 'Serial number',
    Dpin: 'DPIN',
    ModifiedQaEquipment: 'QA equipment modified',
    Identification: 'Identification',
    AddedJobOccurrence: 'Job added',
    ExecutionState: 'State',
    ModifiedJobOccurrence: 'Job modified',
    DeletedJobOccurrence: 'Job deleted',
    StatePersisted: 'State',
  },
  Host: 'Host',
  IAccept: 'I accept',
  IAcceptAllTermsAndConditions:
    'I accept all terms and conditions of the End User License Agreement (EULA)',
  ID: 'ID',
  IDecline: 'I decline',
  IOMapping: 'IO Mapping',
  IPINInUse: 'IPIN in use',
  IUID: 'IUID',
  IUnderstandAndHaveCreatedABackup: 'I understand and have created a backup',
  Identification: 'Identification',
  Ignored: 'Unignore',
  ImageHere: 'Image here',
  ImagingAlignmentMethodEnum: {
    KVCBCTImaging: 'kV CBCT imaging',
    PlanarKVImaging: 'Planar kV imaging',
    PlanarMVImaging: 'Planar MV imaging',
  },
  ImagingMethod: 'Imaging Method',
  InOrderToContinueYouNeedToAcceptEula:
    'To proceed, please review and accept the End User License Agreement (EULA).',
  Included: 'Software components',
  Info: 'Info',
  Input: 'input',
  InputRange: 'Input range',
  InputRangeForExecution: 'Input range for execution',
  InputRangeMax: 'Input range max',
  InputRangeMin: 'Input range min',
  InsertAddressPlaceholder:
    '[Company Name]\nExample Street 100\n12345 Sampletown\n\nTel: 0123 456789\nEmail: info@example.com\nWeb: www.example.com',
  InsertThePasswordYourSslCertificateHasBeenEncryptedWith:
    'Enter the password with which your TLS certificate was encrypted.',
  InstallLicenseFile: 'Install license file',
  Installation: {
    Database: {
      Parameter_paramName_IsNotAllowedMsg:
        'Parameter "{{paramName}}" is not allowed in additional parameters. It should be set using the individual input fields.',
      TrustServerCertificateMsg:
        'Trust Server Certificate parameter is automatically added by the system and should not be included in additional parameters.',
      InvalidFormatMsg: 'Invalid format. Enter "key=value;" pairs',
    },
  },
  InstallationAndUpdates: 'Installation and updates',
  InstallationConfiguration: 'Installation Configuration',
  InstallationID: 'Installation ID',
  InstallationIsCompletedMsg: 'The installation is completed. You can now',
  InstallationName: 'Installation name',
  InstallationNameMsg: 'The installation name will be displayed in the UNICHECK Software.',
  InstallationNameSaved: 'Installation name saved.',
  InstallationPIN: 'Installation PIN',
  InstalledOn: 'Installation date',
  InstalledVersion: 'Version',
  Instance: 'Instance',
  InstitutionLogoAddress: 'Institution logo & Address',
  InstructionForTaskExecution: 'Instruction for task execution',
  InstructionManual: 'www.ptw-eIFU.com',
  InstructionManualLabel: 'Instruction manual',
  InstructionManualUrl: 'http://www.ptw-eIFU.com',
  Instruction_one: 'Instruction',
  Instruction_other: 'Instructions',
  Instructions: 'Instructions',
  InstructionsForIsocenterAlignment: 'Instruction for isocenter alignment',
  InstructionsForOrientation: 'Instruction for orientation',
  InstructionsForPositioningOnCouch: 'Instruction for positioning on couch',
  InstructionsPlaceholder: 'Enter an instruction for task execution...',
  IntegerNumber: 'Integer number',
  IntegratedDatabase: 'Integrated Microsoft SQL Server – Express edition',
  IntegratedDatabaseWillBeUsedMsg: 'This choice will switch to the integrated database.',
  IsUsageEnabledEvaluation: 'Use in evaluations',
  IsUsageEnabledSetup: 'Use in setups',
  IsocenterAlignment: 'Isocenter alignment',
  IssuedBy: 'Issued by',
  Item_one: 'Item',
  Item_other: 'Items',
  ItemsPerPage: 'Items shown',
  JobComment_one: 'Job comment',
  JobComment_other: 'Job comments',
  JobCompleted: '{{name}} | {{iuid}} completed',
  JobConfigurationAutoApprove: 'Auto-approval if all work items pass.',
  JobConfigurationDeletionEffectsMsg:
    'When deleting the job configuration, all scheduled jobs that have not yet been executed will also be deleted. Scheduled jobs that are already started or completed will not be affected.\n\n{{hint}}',
  JobConfigurationExecutionAssignmentHeader: 'Assignment for execution',
  JobConfigurationNoReviewRequiredMsg: 'No review defined.',
  JobConfigurationReferencesBannerMsg: 'Please note that modifications may impact existing jobs.',
  JobConfigurationReferencesDescriptionMsg:
    'Changes to the job configuration apply to all scheduled jobs that haven’t started yet.\n\nNote: Work items in jobs that already have results remain unaffected by changes.',
  JobConfigurationReviewAssignmentHeader: 'Assignment for review',
  JobConfigurationReviewRequired: 'Job review required',
  JobConfiguration_one: 'Job configuration',
  JobConfiguration_other: 'Job configurations',
  JobConfigurations: { Label: 'Job configurations' },
  JobExecution: 'EXECUTION',
  JobExecutionApproveConfirmationTitle: 'Approve job',
  JobExecutionCloseMeasurementConfirmationMsg:
    'The ongoing measurement will be stopped. Existing measurements will be saved.',
  JobExecutionComplete: 'Complete',
  JobExecutionCompleteAndReview: 'Send to review',
  JobExecutionCompleteAndReviewConfirmationMsg:
    'There are still work steps that did not pass.\nAre you sure you want to complete the job and send it for review?',
  JobExecutionCompleteAndReviewConfirmationTitle: 'Complete job & Send to review',
  JobExecutionCompleteConfirmationMsg:
    'There are still work steps that did not pass.\nAre you sure you want to complete the job?',
  JobExecutionCompleteConfirmationTitle: 'Complete job',
  JobExecutionCompletedBy: 'Completed by',
  JobExecutionContinue: 'Continue',
  JobExecutionEnd: 'Execution end',
  JobExecutionPauseAndClose: 'Pause & Close',
  JobExecutionProgress: 'Result summary',
  JobExecutionRejectConfirmationMsg: 'Enter a reason for rejecting this job.',
  JobExecutionRejectConfirmationTitle: 'Reject job',
  JobExecutionReopen: 'Reopen',
  JobExecutionReview: 'Review',
  JobExecutionSkip: 'Skip',
  JobExecutionSkipAll: 'Skip all work steps',
  JobExecutionStart: 'Start',
  JobExecutionStatus: 'State',
  JobExecutionapproveConfirmationMsg:
    'Some work items did not pass.\nYou can leave a comment before approval.',
  JobGroup: { open: 'Jobs to execute', review: 'Jobs to review', completed: 'Finished jobs' },
  JobOccurrenceParentedBy: 'Job configuration',
  JobOccurrencePeriodOfExecution: 'Period of execution',
  JobOccurrencePlannedPeriodOfExecution: 'Period of execution',
  JobOccurrence_one: 'Job',
  JobOccurrence_other: 'Jobs',
  JobOccurrences: { Label: 'Jobs' },
  JobReport: 'Job report',
  JobResultsOverview: 'Job results overview',
  JobSentForReview: '{{name}} | {{iuid}} sent for review',
  Job_one: 'Job',
  Job_other: 'Jobs',
  Keyword: 'Keyword',
  Language: 'Language',
  LanguageAndTimezone: 'Language & Time Zone',
  Languages: 'Languages',
  LastCalibrationReportedByDevice: 'Last calibration reported by device',
  LastModification: 'Last modification',
  LastModificationTime: 'Last modification',
  LastName: 'Last name',
  LastReportedDateAndTime: 'Last reported date and time',
  LastSeen: 'Last activity',
  LatestComment: 'Latest comment',
  Leave: 'Leave',
  LicenseBundle: 'Bundle',
  LicenseBundleDescriptionEnum: {
    Basic: 'Description of the "Basic" bundle',
    Standard: 'Description of the "Standard" bundle',
    Pro: 'Description of the "Pro" bundle',
  },
  LicenseBundleLabelEnum: {
    Basic: 'Basic',
    Pro: 'Pro',
    Standard: 'Standard',
    Unicheck: 'UNICHECK Software',
  },
  LicenseDetails: 'License details',
  LicenseDevices: 'Licensed devices',
  LicenseHasExpired: 'License expired',
  LicenseHasExpiredMsg: 'The license has expired.',
  LicenseHasExpiredRemedy: 'Please contact PTW support to renew your license.',
  LicenseInformation: 'License information',
  LicenseIsDemo: 'This is a demo license!',
  LicenseIsUpToDate: 'Your current license is already up to date',
  LicenseNotFound: 'No license found for this installation!',
  LicenseOptionDescriptionEnum: {
    DeploymentServices: 'Description of the "Deployment Services" option',
    DosimetrySchoolTraining: 'Description of the "Dosimetry School Training" option',
    LocationManagement: 'Description of the "Location Management" option',
  },
  LicenseOptionIsDemo: 'This is a demo option!',
  LicenseOptionLabelEnum: {
    DeploymentServices: 'Deployment Services',
    DosimetrySchoolTraining: 'Dosimetry School Training',
    LocationManagement: 'Location Management',
  },
  LicenseOption_one: 'License option',
  LicenseOption_other: 'License options',
  LicensePlan: 'License plan',
  LicensePlanDealType: 'Deal',
  LicensePlanTypeDescriptionEnum: {
    PayWhatYouUse: 'Description of the "Pay what you use" plan',
    Saving: 'Description of the "Saving" plan',
    Exceptional: 'Description of the "Exceptional" plan',
  },
  LicensePlanTypeLabel: 'Plan type',
  LicensePlanTypeLabelEnum: {
    Exceptional: 'Exceptional',
    PayWhatYouUse: 'Pay what you use',
    Saving: 'Saving',
  },
  LicensePlanWorkPointsPackage: 'Work points per year',
  License_one: 'License',
  License_other: 'Licenses',
  LicensesDescriptionMsg: 'View software and device licenses.',
  LicensesManagementNavigationMsg: 'View software and device licenses.',
  LimitType: {
    Absolute: 'Absolute limit',
    Relative: 'Relative',
    WithoutEvaluation: 'Without evaluation',
  },
  LimitTypeLabel: 'Limit type',
  Limit_one: 'Limit',
  Limit_other: 'Limits',
  ListOrderMsg: 'The order of the list entries can be changed in the task configuration.',
  LoadingPrintPreview: 'Loading print preview...',
  LocationManagementNavigationMsg:
    'Define geographic and organizational structures to manage permissions within larger organizations.',
  LocationNameAlreadyExisting: 'Name already in use for another location.',
  LocationType: 'Location type',
  LocationTypeEnum: {
    Clinic: 'Clinic',
    Department: 'Department',
    Organization: 'Organization',
    Room: 'Room',
    Site: 'Site',
  },
  Location_one: 'Location',
  Location_other: 'Locations',
  Locations: { Label: 'Locations' },
  LocationsDescriptionMsg:
    'Define geographic and organizational structures to manage permissions within larger organizations.',
  LockedToPreventSelfLockoutMsg:
    'This and all preceding options are locked to prevent removing own permissions needed to modify permissions.',
  LoginForTenants: 'Login for tenants',
  Logo: 'Logo',
  Logs: 'Logs',
  LogsDescriptionMsg: 'Manage log entries.',
  LowerFailedLimit: 'Lower failed limit',
  LowerQuartile: 'Lower quartile',
  LowerWarningLimit: 'Lower warning limit',
  Maintenance: 'Maintenance mode',
  MaintenanceMode: 'Maintenance mode',
  MaintenanceModeIsEnabledMsg:
    'The server is currently undergoing maintenance. During this time, only the user who has activated the maintenance mode will be able to sign in.',
  ManageBackupSettings: 'Manage backup settings',
  Management: 'Management',
  Manual: 'Manual',
  ManualAlignmentMethod: 'Manual alignment method',
  ManualInput: 'Manual input',
  Manufacturer: 'Manufacturer',
  ManufacturerCity: '79115 Freiburg – GERMANY',
  ManufacturerEmail: 'info@ptwdosimetry.com',
  ManufacturerModel: 'Manufacturer model',
  ManufacturerName: 'PTW Freiburg',
  ManufacturerPhone: '+49 761 49055-0',
  ManufacturerStreet: 'Lörracher Str. 7',
  ManufacturerWebsite: 'www.ptwdosimetry.com',
  ManufacturersAndOrModels: 'Manufacturers | Models',
  Max: 'Max',
  Maximum: 'Maximum',
  Mean: 'Mean',
  MeasurementFinished: 'Measurement finished',
  MeasurementResult: 'Result',
  MeasurementStatus: {
    Finished: 'Measurement finished',
    Initializing: 'Waiting for device',
    ReadyForBeam: 'Start irradiation',
    BeamDetected: 'Beam on detected - Measuring',
    ProcessingResults: 'Beam on detected - Measuring',
    Error: 'Error occurred',
    ZeroMeasuring: 'Zero measurement running',
  },
  MeasurementWorkItem: 'Measurement',
  Measurement_one: 'Measurement',
  Measurement_other: 'Measurements',
  Mechanical: 'Mechanical properties',
  Median: 'Median',
  MedicalDeviceSerialNumberDisabledReasonTooltipMsg:
    'The serial number cannot be changed for devices that are in use.',
  MedicalSystemBeamLimitingDeviceTypeEnum: {
    Accuray_FixedCollimators: 'Fixed Collimators',
    Accuray_INCISE: 'INCISE Multileaf Collimator',
    Accuray_Iris: 'Iris Variable Aperture Collimator',
    Accuray_Radixact: 'Radixact',
    Accuray_TomoTherapy: 'TomoTherapy',
    Akesis_AkesisGalaxy: 'AkesisGalaxy',
    Best_GammaBeam: 'GammaBeam',
    Brainlab_m3_MLC: 'm3-MLC',
    Elekta_Agility: 'Agility',
    Elekta_BeamModulator: 'BeamModulator',
    Elekta_GammaKnife: 'Gamma Knife',
    Elekta_Harmony: 'Harmony',
    Elekta_MLCi: 'MLCi',
    Elekta_MLCi2: 'MLCi2',
    Elekta_Unity: 'Unity',
    IntraOp_Mobetron: 'Mobetron',
    MDS_Theratron: 'Theratron',
    None: 'None',
    OtherBeamlimitingDeviceType: 'Other',
    Panacea_BHABHATRON: 'BHABHATRON',
    SIT_LIAC: 'LIAC',
    SIT_NOVAC11: 'NOVAC11',
    UJP_TERABALT: 'TERABALT',
    Varian_Halcyon: 'Halcyon',
    Varian_HDMLC120: 'HDMLC120',
    Varian_MLC52: 'MLC52',
    Varian_MLC80: 'MLC80',
    Varian_MLC120: 'MLC120',
    ViewRay_MRIdian: 'MRIdian',
    Xcision_GammaPod: 'GammaPod',
    Zap_Zap_X: 'Zap-X',
  },
  MedicalSystemBeamProductionEnum: {
    Co_60: 'Cobalt-60',
    Linac: 'Linear Accelerator',
    Other: 'Other',
  },
  MedicalSystemChangedNotification:
    'Medical system changed. Please check your beam quality and dose rate available to the new medical system if applicable.',
  MedicalSystemEntity_one: 'Medical system',
  MedicalSystemEntity_other: 'Medical systems',
  MedicalSystemParameter_one: 'Medical system setup parameter',
  MedicalSystemParameter_other: 'Medical system setup parameters',
  MedicalSystemSetups: 'Medical system setups',
  MedicalSystemSubCategoryEnum: {
    Brachytherapy: 'Brachytherapy',
    CT: 'CT',
    HIS: 'HIS',
    kVTherapy: 'kV therapy',
    LightIonTherapy: 'Particle therapy',
    MRT: 'MRT',
    MVTherapy: 'MV therapy',
    None: 'None',
    OIS: 'OIS',
    OtherImagingMachine: 'Other imaging machine',
    OtherPDMS: 'Other patient data management system',
    OtherTreatmentMachine: 'Other treatment machine',
    PACS: 'PACS',
    PET_CT: 'PET-CT',
    PET_MRT: 'PET MRT',
    SPECT: 'SPECT',
    OtherMedicalSystem: 'Other medical system',
    TPS: 'Treatment planning system',
    OtherSoftware: 'Other software',
  },
  MedicalSystemSubModelEnum: {
    BHABHATRON_2: '2',
    BHABHATRON_3i: '3i',
    Clinac_21EX: '21 EX',
    Clinac_21iX: '21 iX',
    Clinac_23EX: '23 EX',
    Clinac_23iX: '23 iX',
    Clinac_2100: '2100',
    Clinac_2100C: '2100 C',
    Clinac_2100CD: '2100 C/D',
    Clinac_2300: '2300',
    Clinac_2300C: '2300 C',
    Clinac_2300CD: '2300 C/D',
    Clinac_CX: 'CX',
    Clinac_DHX: 'DHX',
    Clinac_Silhouette: 'Silhouette',
    Clinac_STx: 'STx',
    Clinac_Tx: 'Tx',
    Cyberknife_G3: 'G3',
    Cyberknife_G4: 'G4',
    Cyberknife_M6: 'M6',
    Cyberknife_S7: 'S7',
    Cyberknife_VSI: 'VSI',
    Galaxy_RTx: 'RTx',
    GammaKnife_Icon: 'Icon',
    GammaKnife_Perfection: 'Perfection',
    NotSpecified: 'Not specified',
    SITLiac_HWL: 'HWL',
    Synergy_BeamModulator: 'BeamModulator',
    Theratron_780E: '780E',
    TomoTherapy_Hi_Art: 'Hi-Art',
    TomoTherapy_HSeries: 'H Series',
    TrueBeam_STx: 'STx',
    TrueBeam_SVC: 'SVC',
    UJP_TERABALT_80: '80',
    UJP_TERABALT_100: '100',
  },
  MedicalSystemTask_one: 'Task',
  MedicalSystemTask_other: 'Tasks',
  MedicalSystemTasks: 'Tasks',
  MedicalSystemType: 'Medical system type',
  MedicalSystem_one: 'Medical system',
  MedicalSystem_other: 'Medical systems',
  MedicalSystems: 'Medical systems',
  Message: 'Message',
  MessageSentWeWillGetInTouchMsg: 'Message sent. We will get in touch with you within 24 hours.',
  MiddleName: 'Middle name',
  Min: 'Min',
  Minimum: 'Minimum',
  Minute_one: 'minute',
  Minute_other: 'minutes',
  MissingCompanyIdOrIpinSetting:
    'License missing. Please load a license. (no Installation PIN or Company ID set)',
  MissingSetupParametersHint: 'Missing setup parameters can be created in the data type section.',
  Mobile: 'Mobile',
  Model: 'Model',
  Modified: 'Modified',
  ModifiedComment: 'Modified comment',
  ModifiedEnumeration: 'Enumeration modified',
  ModifiedUnit: 'Modified unit',
  Month_one: 'month',
  Month_other: 'months',
  MoreInformation: 'More information.',
  MoreThan_maximum_DataSetsAvailable_count_PleaseNarrowDownTheSelectionMsg:
    'Too many data sets found ({{count}}). Please refine your selection using filters.',
  MostCommon: 'Most common',
  Name: 'Name',
  NewCalibration: 'New calibration',
  NewCalibrationCertificate: 'New calibration',
  NewCalibrationCertificateAllReferenceMeasurementsMustBeRenewedMsg:
    'After activating the calibration, all reference measurements that were performed with this QA equipment must be renewed.',
  NewDatabaseWillBeCreatedMsg:
    'You can enter a new database name. If the database does not yet exist, we will create it for you.',
  NewPassword: 'New password',
  NewSSLCertificateAdded: 'New TLS certificate added',
  Next: 'Next',
  Next30days: 'Next 30 days',
  Next7days: 'Next 7 days',
  No: 'No',
  NoActivationLinkSentMsg: 'The activation link can be sent in the details of a user account.',
  NoActivationLinkSentYetMsg: 'This user has not received an account activation link yet.',
  NoApprovalRequired: 'No approval required',
  NoAssignedRoles: 'No role assigned',
  NoAssignedRolesMsg:
    'In order to enable the user to use any feature in <logo>, at least one role must be assigned.',
  NoBackupFilesFound: 'No backup files found',
  NoBatteryData: 'Unknown',
  NoBrand: 'No brand',
  NoCategoriesSelectedMsg: 'No categories selected.',
  NoData: 'No data',
  NoDosimetryAndQaEquipmentsAvailable: 'No QA equipment selected.',
  NoElectronBeamQualitiesAndDoseRatesEnabled: 'No electron beam quality selected.',
  NoElectronBeamQualitiesAvailable: 'No electron beam quality available.',
  NoFilterSelected: 'Please select a filter to find data sets.',
  NoFurtherTargetAreasCanBeAdded:
    'In order to configure more target areas, please add further medical systems.',
  NoInstructionsAvailable: 'No instruction defined.',
  NoItemsHaveBeenAddedToDosimetryAndQa:
    'No items available. Please add and register your equipment to use it in this task.',
  NoJobConfigurationAdded: 'No jobs to execute.',
  NoJobConfigurationReviewPending: 'No jobs pending review.',
  NoJobOccurrencesCompleted: 'No jobs finished yet.',
  NoJobsConfigured: 'No jobs configured',
  NoMeasurements: 'No measurements are performed yet.',
  NoMedicalSystemsConfigured: 'No medical systems configured',
  NoPermissionForAddEntity:
    'You do not have the permission to add {{entity}}. Contact your administrator.',
  NoPermissions: 'No permissions',
  NoPermissionsForThisPage:
    'You do not have permissions to open this page.\nPlease contact your administrator if you need access.',
  NoPermissionsToActivateCalibrationCertificateMsg:
    'You do not have the permissions to activate the calibration.\nContact your administrator.',
  NoPhotonBeamQualitiesAndDoseRatesEnabled: 'No photon beam quality selected.',
  NoPhotonBeamQualitiesAvailable: 'No photon beam quality available.',
  NoQaEquipmentAvailableTooltip:
    'QA equipment not available. Please add and register your equipment first to use it in the task.',
  NoQaEquipmentConfigured: 'No QA equipment configured',
  NoResultsFound: 'No results found.',
  NoSetupParameterCombinationsMsg: 'No setup combinations available.',
  NoSingleSetupParametersAddedYet: 'No setup parameter selected.',
  NoTasksConfigured: 'No tasks configured',
  NoUserIdSelected: 'No User ID selected',
  NoWorkPlannedForThisJobMsg: 'The worklist for this job does not contain any work items.',
  No_updateType_InProgress: 'No {{updateType}} in progress.',
  NominalBeamEnergy: 'Nominal beam energy',
  None: '(None)',
  NotChangeableBecauseOfRightsOrSafetyMsg:
    'You cannot change the availability of your own user account.',
  NotDue: 'Due in {{durationText}}',
  NotExecutableReasons: {
    JobConfigurationNotAvailable: 'The job configuration is not enabled.',
    TargetSystemNotAvailable: 'The medical system is not available.',
    SupportSystemNotEnabled: 'QA equipment not enabled.',
    NoWorkStepsAvailable: 'There is no work planned.',
    CalibrationNotActive: 'QA equipment does not have an active calibration.',
    NoReferenceMeasurementsAvailable:
      'Reference measurements are missing for all work steps. Provide them first to execute the job.',
    InExecutionState: 'This job is currently being executed.',
    InReviewState: 'This job is currently being reviewed.',
  },
  NotForClinicalUseMsg:
    'This is to be used only for test purposes.\nIt must not be used for legally relevant clinical work.\nPTW Freiburg is not responsible for consequences resulting from\nthe use of this prototype.',
  NotForClinicalUseTitle: 'Prototype (not for clinical use)',
  NotOnDetectorLayout: 'Not on detector layout',
  NotReviewableReasons: {
    JobConfigurationNotAvailable: 'The job configuration is not enabled for this job.',
    InReviewState: 'This job is currently being reviewed.',
  },
  NotYetSupported: 'Not yet supported',
  Note: 'Note',
  NoteEvaluationUnitDerived:
    'Note: The evaluation unit is derived from the unit specified in the definition and the selected evaluation type.',
  Notifications: 'Notifications',
  Now: 'Now',
  NumActiveWorkItems: 'Active / Total work items',
  NumberOfDataPoints: 'Number of data points',
  NumberOfDisplayedDecimals: 'Number of displayed decimals',
  Numeric: 'Numeric',
  Ok: 'OK',
  OnlyCalFileTypeAllowedMsg: 'Only files of type .cal are allowed.',
  Open: 'Open',
  OpenJobInNewTab: 'Open job in new tab',
  OpenSourceSoftware: 'open source software',
  Option: 'Option',
  OptionalCommentPlaceholder: 'Your comment (optional)',
  Orientation: 'Orientation',
  OtherManufacturer: 'Other manufacturer',
  OtherManufacturerMsg:
    'You can create QA equipment models from other manufacturers when you select a type.',
  OtherUsersWillBeLoggedOut: 'Other users will be logged out',
  OtherUsersWillBeLoggedOutMsg:
    'If other users are still using the Software they will be logged out',
  OtherWithAmount_one: '+{{count}} other',
  OtherWithAmount_other: '+{{count}} others',
  OutdatedCalibrations: 'Outdated calibration information',
  Output: 'Output',
  Overdue: 'Overdue',
  P41AddonBeamConstancyCheck: 'UNICHECK Beam Constancy Check',
  P41AddonManualTask: 'UNICHECK Manual Task',
  PageNotFound: 'Page not found',
  PageNotFoundMessage:
    "Looks like this page doesn't exist or can't be found. Make sure the URL is correct.",
  PageText: '{0}-{1} of {2}',
  Pages_Administration_User_ResetPassword: 'Reset password',
  ParameterCombination_other: 'Parameter combinations',
  ParameterGroupingEnum: { ImagingSectionGroup: 'Imaging section group' },
  ParameterName: 'Parameter name',
  ParameterValues: 'Value(s)',
  Parameter_one: 'Parameter',
  Parameter_other: 'Parameters',
  Password: 'Password',
  PasswordChangedMsg: 'Your password has been changed successfully!',
  PasswordComplexityViolationMsg: 'Minimum 12 characters.',
  PasswordHasBeenResetSuccessfullyMsg:
    'Your password has been reset successfully.\nYou can now sign in to your account.',
  PasswordUpdated: 'Password updated',
  PatientID: 'Patient ID',
  PatientName: 'Patient name',
  PercentageOfAbsorbedDose: 'Percentage of absorbed dose',
  PerformanceLogs: 'Performance logs',
  PeriodHint: {
    Daily: 'Define the period in which daily recurring jobs should be created.',
    Weekly: 'Define the period in which weekly recurring jobs should be created.',
    Monthly: 'Define the period in which monthly recurring jobs should be created.',
    Yearly: 'Define the period in which yearly recurring jobs should be created.',
  },
  Permission_one: 'Permission',
  Permission_other: 'Permissions',
  Permissions: {
    AccountsAssignAndRemoveLicense: 'Assign & Remove license',
    CommentsDelete: 'Delete own comments',
    CommentsDeleteExternal: 'Delete any comment',
    CommentsEdit: 'Edit own comments',
    DosimetryAndQa: 'QA equipment',
    DosimetryAndQaMyPtwViewList: 'View myPTW equipment',
    GeneralActivate: 'Activate',
    Add: 'Add',
    Archive: 'Archive',
    Delete: 'Delete',
    Edit: 'Edit',
    Register: 'Registration',
    GeneralSetAvailability: 'Set availability',
    Unregister: 'Unregister',
    View: 'View',
    ViewDetail: 'View detail',
    ViewList: 'View list',
    Global: 'Global permissions',
    GlobalAccountSecurity: 'Account security',
    Jobs: 'Jobs',
    Local: 'Local permissions',
    MainPtw100Poc: 'MainPtw100Permissions (POC)',
    MedicalSystem: 'Medical systems',
    MedicalSystemDataServices: 'Edit data services',
    Results: 'Results',
    Roles: 'Roles',
    DeviceManagement: 'Device management',
    TaskAndJobManagement: 'Task and job management',
    Accounts: 'Accounts',
    Schedule: 'Schedule',
    Locations: 'Locations',
    Units: 'Units',
    Enumerations: 'Enumerations',
    Quantities: 'Quantities',
    Tasks: 'Tasks',
    TaskTemplates: 'Task templates',
    Dashboard: 'Dashboard',
    Protocols: 'Protocols',
    System: 'System',
    Licenses: 'Licenses',
    Setup: 'Setup',
    MedicalSystems: 'Medical systems',
    GeneralResetPassword: 'General reset password',
    GeneralAssignLicense: 'General assign license',
    GeneralManage: 'General manage',
    GeneralSettings: 'General settings',
    GeneralAuditLogs: 'General audit logs',
    GeneralPerformanceLogs: 'General performance logs',
    GeneralAccountSecurity: 'General account security',
    GeneralDevelopment: 'General development',
    GeneralInstallationUpdates: 'General installation updates',
    GeneralInstallationUpdatesInstance: 'General installation updates instance',
    GeneralInstallationUpdatesUpdatesUpgrades: 'General installation updates upgrades',
    GeneralBackupRestore: 'General backup restore',
    GeneralBackupRestoreSettings: 'General backup restore settings',
    GeneralBackupRestoreRestore: 'General backup restore restore',
    GeneralSession: 'General session',
    GeneralSessionSuspension: 'General session suspension',
    GeneralUpload: 'General upload',
    UserAccounts: 'User accounts',
    Tenants: 'Tenants',
    Comments: 'Comments',
    Setups: 'Setups',
    Upgrade: 'Upgrade',
    Texts: 'Texts',
    JobConfigurations: 'Job configurations',
    JobOccurrences: 'Jobs',
    ResultManagement: 'Result management',
    ViewDatasets: 'View trends',
    ReportManagement: 'Manage report',
  },
  PermissionsAssigned: 'permissions assigned',
  Phone: 'Phone',
  PhotonBeamQuality: 'Photon beam quality',
  PhotonBeamQualityDoseRates: 'Photons',
  PlaceholderCouchIndexingPoint: 'Enter the couch indexing point...',
  PlanDate: 'Plan date',
  PlanDescription: 'Plan description',
  PlanIntent: 'Plan intent',
  PlanLabel: 'Plan label',
  PlanName: 'Plan name',
  PlatformManagement: 'Settings',
  PleaseRegisterMyEquipmentMsg: 'e.g., Please register this equipment.',
  Port: 'Port',
  PositioningOnCouch: 'Positioning on couch',
  PositioningOnCouchDescription: 'Positioning on couch description',
  PowerAdapter: 'Power adapter',
  Preferences: 'Preferences',
  PreferencesOfName: 'Preferences of {{name}}',
  Preview: 'Preview',
  PrimaryFluenceShaping: 'Primary fluence shaping',
  PrintReport: 'Print Report',
  Progress: {
    PassedWorkstep: 'Passed work steps',
    WorkstepWithWarning: 'Work steps with warning',
    FailedWorkstep: 'Failed work steps',
    WorkstepWithoutEvaluation: 'Work steps without evaluation',
    SkippedWorkstep: 'Skipped work steps',
    OpenWorksteps: 'Open work steps',
  },
  Protocol_one: 'Protocol',
  Protocol_other: 'Protocols',
  Ptw: 'PTW',
  PtwProductCatalog: 'PTW product catalog',
  PtwProductCatalogMsg: 'You can select PTW products from the product catalog below.',
  PtwProductCatalogTooltipMsg: 'Future software releases will include an extended product catalog.',
  PtwQuantityDefinitionsFormMsg:
    'A definition describes a quantity and helps to understand its characteristics, whether it has parameters, which ones they are, and what output it generates, as well as how this output is produced.',
  PtwQuantityEvaluationQuantitiesFormMsg: 'Evaluation quantities - Add evaluation quantity!',
  PtwQuantityEvaluationQuantityAddTooltipFromMsg:
    'In order to add an evaluation quantity at least one definition must be provided.',
  PtwQuantityEvaluationQuantityRangeFromMsg:
    'Input range is used in manual check during work item execution.',
  Publisher: 'Publisher',
  PublisherAuthor: 'Publisher/Author',
  QaEquipmentRegistrationMsg:
    'Register your equipment to benefit from full functionality of the UNICHECK Software.',
  QaEquipmentSetupOptionEnum: { Custom: 'Custom', Ruby: 'RUBY', Unicheck: 'UNICHECK' },
  QaEquipmentSubCategoryEnum: {
    Accessory: 'Accessory',
    ArrayDetector: 'Array detector',
    DetectorHolder: 'Detector holder',
    Electrometer: 'Electrometer',
    Interface: 'Interface',
    Multimeter: 'Multimeter',
    OtherDetector: 'Other detector',
    OtherDosimetryQaEquipment: 'Other QA equipment',
    Phantom: 'Phantom',
    SingleDetector: 'Single detector',
    WaterTank: 'Water phantom',
  },
  Quantities: { Label: 'Quantities' },
  QuantitiesAndUnits: 'Data types',
  QuantitiesAndUnitsDescriptionMsg: 'Manage quantities, enumerations, texts and units.',
  QuantityDescriptionLabelEnum: {
    NominalPhotonBeamEnergyMsg:
      'The "Nominal photon beam energy" refers to the maximum photon energy of a bremstrahlung X-ray beam produced through accelerated electrons that strike a target.',
    NominalElectronBeamEnergyMsg:
      'The "Nominal electron beam energy" refers to the energy of electrons being accelerated within an electromagnetic field (e.g., in a waveguide of a linac).',
    BeamQualityFactorMsg: 'The "Beam quality factor" is a measure for the detected beam energy.',
    BeamQualityDoseRateMsg:
      'The "Dose rate" is the amount of radiation dose absorbed per unit of time.',
    MonitorPresetMsg:
      'The "Monitor preset" represents the number of monitor units that are to be delivered by a linac or orthovoltage unit.',
    RadiationFieldSizeMsg:
      'The "Radiation field" represents the dimension of a square or a circular shaped radiation field. For square fields the dimension is represented by the length in the X- and Y-direction while the diameter is used for circular fields.',
    RadiationFieldEdgeMsg:
      'The "Radiation field edges" represent the local positions between which the radiation field is defined.',
    JawPositionMsg:
      'The jaw positions refer to the positions of the beam-limiting device (collimator) jaws used of the linear accelerator.',
    NumberOfBlocksMsg: 'Number of blocks',
    CollimatorAngleMsg:
      'The "Collimator angle" specifies the rotational angle of the collimator of a linac.',
    GantryAngleMsg:
      'The "Gantry angle" refers to the rotational angle of a radiation source which is mounted on a gantry alongside other components (such as a collimator or radiation detectors).',
    WedgeAngleMsg:
      'The "Wedge angle" is defined to be the angle through which an isodose curve is tilted at the central ray of a beam at the 10 cm depth.',
    CouchAngleMsg: 'Couch angle',
    ImageReceptorAngleMsg: 'Image receptor angle',
    ImagePositionMsg: 'Image position',
    SourceToImagePlaneDistanceMsg: 'Source-to-image plane distance',
    ReferencedReferenceImageNumberMsg: 'Referenced reference image number',
    AreaSymmetryMsg:
      'The area or 2D symmetry is defined as the maximum value of the ratio of the higher to the lower absorbed dose at any two positions symmetrical to the radiation beam axis and inside the flattened area of a 2D dose distribution.  \nThis definition is based on IEC 60976: 2007-10, 9.1.3.',
    AreaFlatnessMsg: 'The "Area flatness" represents the uniformity of a 2D dose distribution.',
    BeamProfileConstancyMsg:
      'The "Beam profile constancy" represents the stability and uniformity of the intensity distribution of a radiation beam over time. Its calculation is based on a 2D dose distribution.',
    BeamDoseOutputMsg:
      'The "Beam dose output" describes the amount of absorbed dose delivered by a treatment machine.',
    SymmetryMsg:
      'The "Profile symmetry" describes the degree of similarity between the dose distribution on one side of the central axis of a 1D dose profile compared to the other side.',
    FlatnessMsg: 'The "Profile flatness" represents the uniformity of a 1D dose profile.',
    PenumbraWidth: 'Penumbra width',
    AirTemperatureMsg:
      'The "Air temperature" refers to the measure of how hot or cold the air is at a specific location and time.',
    AirPressureMsg:
      'The atmospheric pressure, also known as "Air pressure", is the pressure within the atmosphere of earth. ',
    StabilityIndexMsg:
      'The "Stability index" describes the maximum dose variation of a 1D dose profile with respect to a reference profile.',
    CAXDeviationMsg:
      'The "CAX deviation" is the distance between the geometrical center of a 1D dose profile and the central beam axis (CAX).',
  },
  QuantityManagementNavigationMsg:
    'View and add quantities and enumerations for use in evaluations and setups.',
  QuantityNameLabelEnum: {
    NominalPhotonBeamEnergy: 'Nominal photon beam energy',
    NominalElectronBeamEnergy: 'Nominal electron beam energy',
    BeamQualityFactor: 'Beam quality factor',
    BeamQualityDoseRate: 'Dose rate',
    MonitorPreset: 'Monitor preset',
    RadiationFieldSize: 'Radiation field',
    RadiationFieldEdge: 'Radiation field edge',
    JawPosition: 'Jaw position',
    NumberOfBlocks: 'Number of blocks',
    CollimatorAngle: 'Collimator angle',
    GantryAngle: 'Gantry angle',
    WedgeAngle: 'Wedge angle',
    CouchAngle: 'Couch angle',
    ImageReceptorAngle: 'Image receptor angle',
    ImagePosition: 'Image position',
    SourceToImagePlaneDistance: 'Source to image plane distance',
    ReferencedReferenceImageNumber: 'Referenced reference image number',
    AreaSymmetry: 'Area (2D) symmetry',
    AreaFlatness: 'Area flatness',
    BeamProfileConstancy: 'Beam profile constancy',
    BeamDoseOutput: 'Beam dose output',
    Symmetry: 'Profile symmetry',
    Flatness: 'Profile flatness',
    PenumbraWidth: 'Penumbra width',
    AirTemperature: 'Air temperature',
    AirPressure: 'Air pressure',
    StabilityIndex: 'Stability index',
    CAXDeviation: 'CAX deviation',
  },
  QuantityNotUsedInEvaluationsMsg: 'This quantity is not used in evaluations.',
  QuantityNotUsedInSetupsMsg: 'This quantity is not used in setups.',
  QuantityValueType: { FloatingPoint: 'floating point number', IntegerNumber: 'integer number' },
  Quantity_one: 'Quantity',
  Quantity_other: 'Quantities',
  Question: 'Question',
  RadiationFieldEdge: 'Radiation field edge',
  RadiationFieldShape: 'Radiation field shape',
  RadiationFieldSize: 'Radiation field',
  RadiationFieldSymmetry: 'Radiation field symmetry',
  RadiationType: 'Radiation type',
  RadiationTypeEnum: {
    Electron: 'Electron',
    Neutron: 'Neutron',
    Photon: 'Photon',
    PhotonFFF: 'Photon FFF',
    Proton: 'Proton',
  },
  Range: 'Input range',
  Recurrence: 'Recurrence',
  ReferenceConditions: 'Reference conditions',
  ReferenceMeasurement: 'Start reference measurement',
  ReferenceMeasurementCalibrationMissing: 'Calibration missing',
  ReferenceMeasurementDialogTitle: 'Reference measurement',
  ReferenceMeasurementInstruction:
    '1. Position UNICHECK according to setup parameters.\n2. Prepare linac according to setup parameters and start irradiation.\n\nThe measurement stops automatically as soon as the beam delivery stops.',
  ReferenceMeasurementMissing: 'Reference measurement missing',
  ReferenceMeasurementMissingMsg: 'Reference measurement missing',
  ReferenceMeasurementOutdated: 'New reference measurement required',
  ReferencePressure: 'Reference pressure',
  ReferenceTemperature: 'Reference temperature',
  ReferencedSOPClassUID: 'Referenced SOP class UID',
  ReferencedSOPInstanceUID: 'Referenced SOP instance UID',
  ReferencedTreatmentMachine: 'Referenced treatment machine',
  ReferenceingEntities: 'Info',
  References: 'Reference',
  Register: 'Register',
  RegisterEquipment: 'Register equipment',
  RegisterEquipmentMsg:
    'During registration, we verify whether the entered device is assigned to your myPTW account (Company ID). To do this, the serial number is cross-checked.',
  RegisterEquipmentWithDpinMsg:
    'During registration, we verify whether the entered device is assigned to your myPTW account (Company ID). To do this, the serial number and DPIN are cross-checked.',
  RegisterIotEquipmentMsg:
    'To be able to use UNICHECK after registration, it needs to be switched on and connected to your local network.',
  RegisterLater: 'Register later',
  RegisterNow: 'Register now',
  Registered: 'registered',
  Registration: 'Registration',
  Reject: 'Reject',
  Related: 'Related',
  ReleaseNotes: 'Release notes',
  ReleasedOn: 'Publication date',
  Remedy: 'Remedy',
  Remove: 'Remove',
  RemoveDefinition: 'Remove definition',
  RemoveDefinitionOfReferencedQuantityTooltipMsg:
    'This definition is not allowed to be removed because the owning quantity is in use.',
  RemoveDefinitionTooltipMsg:
    'To delete this definition, you must delete all referenced definition parameter presets first.',
  RemoveOldBackups: 'Remove old backups',
  RemoveParameter: 'Remove parameter',
  RemovePredefinedDefinitionTooltipMsg:
    'This definition is not allowed to be removed because it is predefined.',
  Repeat: 'Repeat',
  Replace: 'Replace',
  ReplaceEntityConfirmationMsg:
    'Are you sure you want to replace this medical system with this one {{entityName}}?',
  ReportType: 'Report type',
  Reports: 'Reports',
  ReportsConfiguration: 'Reports',
  ReportsConfigurationFormDescriptionMsg:
    'Upload the logo and address of your institution. \nThey will automatically appear in the header of all reports generated in jobs.',
  ReportsDescriptionMsg: 'Manage template for reports.',
  RequestAssignmentOfSerialNumber: 'Request assignment of serial number to Company ID',
  RequestAssignmentToCompanyId: 'Request assignment to Company ID',
  Required: 'required',
  RequirementToCreateTargetArea:
    'In order to add a target area, at least one medical system must be defined.',
  RequirementToCreateTaskItemTargetArea:
    'In order to add a target area, at least one medical system must be defined.',
  ResendActivationLink: 'Resend activation link',
  ResetFilter_one: 'Clear all',
  ResetFilter_other: 'Clear all',
  ResetPassword: 'Reset password',
  ResetPasswordInstructionsSentMsg:
    'If this email address is in our database,\nwe will send you an email to reset your password.',
  ResetPasswordLinkExpiredMsg:
    'A problem occurred. Your link has either expired or is invalid.\nYou can request a new one and try again.',
  ResetToDefault: 'Reset to default',
  ResetZoom: 'Reset zoom',
  RestoreBackups: 'Restore backups',
  ResultValue: 'Result value',
  Result_one: 'Result',
  Result_other: 'Results',
  ResultsManagement: 'Result management',
  ResultsSummary: 'Results summary',
  RetryUpload: 'Retry upload',
  ReviewAssignment: 'Reviewer',
  ReviewPending: 'Sent for review',
  ReviewRoles: 'Roles',
  ReviewUsers: 'Users',
  Reviewer: 'Reviewer',
  RoleHadAssignments: 'Role {{0}} already was assigned.',
  RoleName: 'Role name',
  RoleStateOfUseEnum: {
    InAdding: 'Adding',
    InEditing: 'Being edited',
    Enabled: 'Enabled',
    Disabled: 'Disabled',
    Archived: 'Archived',
    Deleted: 'Deleted',
    NoActivationSent: 'No activation sent',
    ActivationPending: 'Activation pending',
  },
  Role_one: 'Role',
  Role_other: 'Roles',
  Roles: {
    Predefined: {
      DescriptionPtw100ItAdministrator:
        'The role "IT administrator" includes comprehensive permissions for managing user accounts, software settings and maintenance.',
      DescriptionPtw100LeadMedicalPhysicist:
        'The role "Lead medical physicist" includes  comprehensive permissions for managing user accounts, application specific configurations, QA equipment, medical systems, tasks, jobs and results. Moreover, it includes selected permissions for maintenance.',
      DescriptionPtw100MedicalPhysicist:
        'The role "Medical physicist" includes comprehensive permissions for managing QA equipment, medical systems, tasks, jobs and results. Moreover, it includes selected permissions for managing user accounts, application specific configurations and maintenance.',
      DescriptionPtw100RadiationTherapist:
        'The role "Radiation therapist" includes selected permissions for managing jobs and results.',
      DescriptionPtw100Service:
        'The role "PTW service" includes permissions for specific service-related functionalities.',
      NamePtw100ItAdministrator: 'IT administrator',
      NamePtw100LeadMedicalPhysicist: 'Lead medical physicist',
      NamePtw100MedicalPhysicist: 'Medical physicist',
      NamePtw100RadiationTherapist: 'Radiation therapist',
      NamePtw100Service: 'PTW service',
    },
    Restrictions: {
      DeviceLocatedInLocationMissing: '{{0}} is missing',
      DeviceLocatedInLocationNotGranted: 'Devices are located in Locations that are not granted.',
    },
    Label: 'Roles',
  },
  RolesNumberOfAssignedAccounts: 'Assigned user accounts',
  RolesPredefinedOptionArchiveMessage:
    'Option is disabled because predefined roles cannot be archived.',
  RolesPredefinedOptionDeleteMessage:
    'Option is disabled because predefined roles cannot be deleted.',
  RolesSystemOptionArchiveMessage: 'Option is disabled because System-Roles cannot be archived.',
  RolesSystemOptionDeleteMessage: 'This option is disabled because system roles cannot be deleted.',
  RolesSystemOptionEditMessage: 'Option is disabled because system roles cannot be edited.',
  RtSystemCategoryEnum: {
    ImagingMachine: 'Imaging machine',
    PDMS: 'Patient data management system',
    QaEquipment: 'QA equipment',
    TreatmentMachine: 'Treatment machine',
    TreatmentWorkflow: 'Treatment Workflow',
    OtherMedicalSystem: 'Other medical systems',
    TPS: 'Treatment planning systems',
    Software: 'Software',
  },
  RtSystemManufacturerEnum: {
    MDSNordion: 'MDS Nordion',
    MS_AB_CT: 'AB-CT',
    MS_Accuray: 'Accuray',
    MS_AgfaHealthCare: 'Agfa Health Care',
    MS_Akesis: 'Akesis',
    MS_ArianeMedicalSystems: 'Ariane Medical Systems',
    MS_BestTheratronics: 'Best Theratronics',
    MS_Brainlab: 'Brainlab',
    MS_Canon: 'Canon',
    MS_Cefla: 'Cefla',
    MS_Dosisoft: 'Dosisoft',
    MS_EckertZiegler: 'Eckert & Ziegler',
    MS_Elekta: 'Elekta',
    MS_Fujifilm: 'Fujifilm',
    MS_GE: 'GE',
    MS_Hitachi: 'Hitachi',
    MS_Iba: 'Iba',
    MS_IntraOp: 'IntraOp',
    MS_Leksell: 'Leksell',
    MS_MDSNordion: 'MDS Nordion',
    MS_medigration: 'medigration',
    MS_Mevion: 'Mevion',
    MS_MinFound: 'MinFound',
    MS_NexusChili: 'Nexus/Chili',
    MS_Other: 'Other manufacturer',
    MS_PanaceaMedicalTechnologies: 'Panacea Medical Technologies',
    MS_Philips: 'Philips',
    MS_ProNova: 'ProNova',
    MS_Prowess: 'Prowess',
    MS_RaySearch: 'RaySearch',
    MS_Sensus: 'Sensus',
    MS_Siemens: 'Siemens',
    MS_SiemensHealthineers: 'Siemens Healthineers',
    MS_SIT: 'SIT',
    MS_Sumitomo: 'Sumitomo',
    MS_Toshiba: 'Toshiba',
    MS_UJP: 'UJP',
    MS_Varian: 'Varian',
    MS_ViewRay: 'ViewRay',
    MS_Xcision: 'Xcision',
    MS_Xstrahl: 'Xstrahl',
    MS_ZapSurgicalSystems: 'Zap Surgical Systems',
    MS_Zeiss: 'Zeiss',
    PTW_Freiburg: 'PTW Freiburg',
  },
  RtSystemModelEnum: {
    Brachy_EckertZiegler_SagiNova: 'SagiNova ',
    Brachy_Elekta_Flexitron: 'Flexitron',
    Brachy_Elekta_microSelectron: 'microSelectron',
    Brachy_Panacea_Karknidon: 'Karknidon',
    Brachy_Sensus_Sculptura: 'Sculptura',
    Brachy_Varian_BRAVOS: 'BRAVOS',
    Brachy_Varian_GammaMedplusiX: 'GammaMedplus iX',
    Brachy_Varian_VariSourceiX: 'VariSource iX',
    IMCT_AB_CT_nuview: 'nu:view',
    IMCT_Canon_Aquilion: 'Aquilion',
    IMCT_Canon_AquilionLB: 'Aquilion LB',
    IMCT_Canon_AquilionLightning: 'Aquilion Lightning',
    IMCT_Canon_AquilionLightningSP: 'Aquilion Lightning SP',
    IMCT_Canon_AquilionOneGenesisEdition350: 'Aquilion One Genesis Edition 350',
    IMCT_Canon_AquilionPrecision: 'Aquilion Precision',
    IMCT_Canon_AquilionPrimeSP: 'Aquilion Prime SP',
    IMCT_Canon_AquilionStart: 'Aquilion Start',
    IMCT_Cefla_NewTom: 'NewTom',
    IMCT_Cefla_NewTom5GXL: 'NewTom 5G XL',
    IMCT_Fujifilm_FCTSpeedia: 'FCT Speedia',
    IMCT_Fujifilm_FCTSpeediaHD: 'FCT Speedia HD',
    IMCT_GE_BrightSpeed: 'BrightSpeed ',
    IMCT_GE_Discovery: 'Discovery',
    IMCT_GE_DiscoveryRT: 'Discovery RT',
    IMCT_GE_LightSpeed: 'LightSpeed',
    IMCT_GE_Optima: 'Optima',
    IMCT_GE_Revolution: 'Revolution',
    IMCT_Hitachi_ScenariaView: 'Scenaria View',
    IMCT_Hitachi_Supria: 'Supria ',
    IMCT_Hitachi_Supria1632: 'Supria 16 / 32',
    IMCT_Hitachi_Supria64128: 'Supria 64 / 128',
    IMCT_MinFound_ScintCare: 'ScintCare',
    IMCT_MinFound_ScintCareBlueSeries: 'ScintCare Blue Series',
    IMCT_MinFound_ScintCareCT16: 'ScintCare CT16',
    IMCT_MinFound_ScintCareCT128: 'ScintCare CT128',
    IMCT_Philips_Brilliance: 'Brilliance',
    IMCT_Philips_iCT: 'iCT',
    IMCT_Philips_Ingenuity: 'Ingenuity ',
    IMCT_Philips_IQonElite: 'IQon Elite',
    IMCT_Philips_MX: 'MX ',
    IMCT_Siemens_SomatomDefinitionEdge: 'Somatom Definition Edge',
    IMCT_SiemensHealth_SOMATOM: 'SOMATOM',
    IMCT_SiemensHealth_SOMATOMConfidenceRTPro: 'SOMATOM Confidence RT Pro',
    IMCT_SiemensHealth_SomatomDrive: 'Somatom Drive',
    IMCT_SiemensHealth_SomatomEdgePlus: 'Somatom Edge Plus',
    IMCT_SiemensHealth_SomatomForce: 'Somatom Force',
    IMCT_SiemensHealth_SomatomgoAll: 'Somatom go.All',
    IMCT_SiemensHealth_SomatomgoNow: 'Somatom go.Now',
    IMCT_SiemensHealth_SOMATOMgoOpenPro: 'SOMATOM go.Open Pro',
    IMCT_SiemensHealth_SomatomgoSlim: 'Somatom go.Slim',
    IMCT_SiemensHealth_SOMATOMgoTop: 'SOMATOM go.Top',
    IMCT_SiemensHealth_SOMATOMgoUp: 'SOMATOM go.Up',
    IMCT_SiemensHealth_SOMATOMgoUpRT: 'SOMATOM go.Up RT',
    IMCT_SiemensHealth_SomatomXcite: 'Somatom X.cite',
    IMCT_Toshiba_Aquilion: 'Aquilion',
    IMCT_Toshiba_AquilionOnePrismEdition: 'Aquilion One Prism Edition',
    IMCT_Toshiba_AquilionOnePrismEdition350: 'Aquilion One Prism Edition 350',
    IMMRT_Canon_Vantage: 'Vantage',
    IMMRT_Canon_VantageElan: 'Vantage Elan',
    IMMRT_Canon_VantageGalan: 'Vantage Galan',
    IMMRT_Canon_VantageOrian: 'Vantage Orian ',
    IMMRT_GE_SIGNA: 'SIGNA',
    IMMRT_Hitachi_Airis: 'Airis ',
    IMMRT_Hitachi_Aperto: 'Aperto ',
    IMMRT_Hitachi_Echelon: 'Echelon',
    IMMRT_Hitachi_EchelonSmart: 'Echelon Smart',
    IMMRT_Hitachi_EchelonSmartPlus: 'Echelon Smart Plus',
    IMMRT_Hitachi_Oasis: 'Oasis ',
    IMMRT_Philips_Ingenia: 'Ingenia',
    IMMRT_SiemensHealth_MAGNETOM: 'MAGNETOM',
    IMMRT_SiemensHealth_MagnetomAltea: 'Magnetom Altea',
    IMMRT_SiemensHealth_MagnetomAmira: 'Magnetom Amira',
    IMMRT_SiemensHealth_MagnetomLumia: 'Magnetom Lumia',
    IMMRT_SiemensHealth_MagnetomPrisma: 'Magnetom Prisma ',
    IMMRT_SiemensHealth_MAGNETOMRTProedition: 'MAGNETOM RT Pro edition',
    IMMRT_SiemensHealth_MAGNETOMSempra: 'MAGNETOM Sempra',
    IMMRT_SiemensHealth_MagnetomSola: 'Magnetom Sola',
    IMMRT_SiemensHealth_MagnetomSpectra: 'Magnetom Spectra',
    IMMRT_SiemensHealth_MAGNETOMTerra: 'MAGNETOM Terra',
    IMMRT_SiemensHealth_MAGNETOMVida: 'MAGNETOM Vida',
    IMPETCT_Canon_Celesteion: 'Celesteion',
    IMPETCT_Philips_GEMINI: 'GEMINI',
    IMPETCT_Philips_VEREOS: 'VEREOS',
    IMPETCT_Siemens_Biograph: 'Biograph',
    IMPETMRT_GE_SIGNA: 'SIGNA',
    IMPETMRT_Philips_Ingenuity: 'Ingenuity',
    IMPETMRT_Siemens_Biograph: 'Biograph',
    IMSPECT_SiemensHealth_SymbiaEvoExcel: 'Symbia Evo (Excel)',
    IMSPECT_SiemensHealth_SymbiaIntevoExcel: 'Symbia Intevo (Excel, Bold)',
    Ion_Hitachi_Carbon_IonTherapySystem: 'Carbon-Ion Therapy System',
    Ion_Hitachi_HybridTherapySystem: 'Hybrid Therapy System',
    Ion_Hitachi_ProtonTherapySystem: 'Proton Therapy System',
    Ion_Iba_Proteus: 'Proteus',
    Ion_Iba_ProteusOne: 'Proteus One',
    Ion_Iba_ProteusPlus: 'Proteus Plus',
    Ion_Mevion_S250: 'S250',
    Ion_Mevion_S250iHyperscan: 'S250i Hyperscan',
    Ion_ProNova_SC360: 'SC360',
    Ion_Siemens_IonTherapySystem: 'Ion Therapy System',
    Ion_Sumitomo_ProtonTherapySystem: 'Proton Therapy System',
    Ion_Toshiba_HeavyIonTherapyEquipmentCI_1000: 'Heavy Ion Therapy Equipment CI-1000',
    Ion_Toshiba_HeavyIonTherapyEquipmentCI_1000s: 'Heavy Ion Therapy Equipment CI-1000s',
    Ion_Varian_ProBeam: 'ProBeam',
    Ion_Varian_ProBeam360: 'ProBeam360',
    kV_Ariane_Papillon: 'Papillon+',
    kV_EckertZiegler_ioRT_50: 'ioRT-50',
    kV_EckertZiegler_T_105: 'T-105',
    kV_EckertZiegler_T_160: 'T-160',
    kV_EckertZiegler_T_200: 'T-200',
    kV_EckertZiegler_T_300: 'T-300',
    kV_Sensus_SRT100: 'SRT 100',
    kV_Xstrahl_RADiantSystem: 'RADiant System',
    kV_Zeiss_INTRABEAM: 'INTRABEAM',
    MV_Accuray_CyberKnife: 'CyberKnife',
    MV_Accuray_Radixact: 'Radixact',
    MV_Accuray_TomoTherapy: 'TomoTherapy',
    MV_Akesis_AkesisGalaxy: 'Akesis Galaxy',
    MV_Best_GammaBeam: 'GammaBeam',
    MV_Brainlab_Novalis: 'Novalis',
    MV_Elekta_Axesse: 'Axesse',
    MV_Elekta_Compact: 'Compact',
    MV_Elekta_GammaKnife: 'Gamma Knife',
    MV_Elekta_Harmony: 'Harmony',
    MV_Elekta_Infinity: 'Infinity ',
    MV_Elekta_Synergy: 'Synergy',
    MV_Elekta_Unity: 'Unity',
    MV_Elekta_VersaHD: 'Versa HD',
    MV_IntraOp_Mobetron: 'Mobetron',
    MV_MDS_Theratron: 'Theratron ',
    MV_Panacea_BHABHATRON: 'BHABHATRON',
    MV_SIT_LIAC: 'LIAC',
    MV_SIT_NOVAC11: 'NOVAC 11',
    MV_UJP_TERABALT: 'TERABALT ',
    MV_Varian_Clinac: 'Clinac',
    MV_Varian_Edge: 'Edge',
    MV_Varian_Ethos: 'Ethos',
    MV_Varian_Halcyon: 'Halcyon',
    MV_Varian_Novalis: 'Novalis',
    MV_Varian_Trilogy: 'Trilogy',
    MV_Varian_TrueBeam: 'TrueBeam',
    MV_Varian_Unique: 'Unique',
    MV_Varian_VitalBeam: 'VitalBeam',
    MV_ViewRay_MRIdian: 'MRIdian',
    MV_Xcision_GammaPod: 'GammaPod',
    MV_Zap_Zap_X: 'Zap-X',
    OtherModel: 'Other model',
    PDMSOIS_Elekta_MOSAIQ: 'MOSAIQ',
    PDMSOIS_Prowess_Panter: 'Panter',
    PDMSOIS_RaySearch_RayCare: 'RayCare',
    PDMSOIS_Varian_ARIA: 'ARIA',
    PDMSPACS_Agfa_EnterpriseImaging: 'Enterprise Imaging',
    PDMSPACS_Fujifilm_Synapse3D: 'Synapse 3D',
    PDMSPACS_medigration_RISPACS: 'RIS/PACS',
    PDMSPACS_Nexus_PACS: 'PACS',
    PDMSPACS_SiemensHealth_syngo: 'syngo',
    TPS_Accuray_Precision: 'Precision',
    TPS_Brainlab_iPLan: 'iPLan',
    TPS_Dosisoft_ISOgray: 'ISOgray',
    TPS_EckertZiegler_SagiPlan: 'SagiPlan ',
    TPS_Elekta_Monaco: 'Monaco',
    TPS_Leksell_GammaPlan: 'GammaPlan',
    TPS_Philips_Pinnacle3: 'Pinnacle³',
    TPS_Prowess_PanterTPS: 'Panter TPS',
    TPS_RaySearch_RayStation: 'RayStation',
    TPS_Varian_BrachyVision: 'BrachyVision',
    TPS_Varian_Eclipse: 'Eclipse',
    TPS_Varian_RapidPlan: 'RapidPlan',
    TPS_Varian_VariSeed: 'VariSeed',
    TPS_Varian_Vitesse: 'Vitesse',
    MV_Elekta_Evo: 'Evo',
  },
  RunUpdateNow: 'Update now',
  RunUpgradeNow: 'Upgrade now',
  SOPClassUID: 'SOP class UID',
  SOPInstanceUID: 'SOP instance UID',
  SOUPLinkText: 'This software is made possible by',
  SSLCertificate: 'TLS certificate',
  SSLCertificateSettingsMsg:
    'This server makes use of the PFX container format. This file should contain all the members of the chain of trust. This includes the certificate itself and its private key as well as the certificates of all the intermediate CAs. The current status of your certificate is shown next.',
  Save: 'Save',
  SaveAndClose: 'Save & Close',
  SaveAndConnect: 'Save & Connect',
  Schedule: 'Schedule',
  SchedulePersonalsManage: 'Manage schedule personals',
  SchedulePersonalsView: 'View personal schedules',
  Scheduling: 'Scheduling',
  Search: 'Search',
  SearchPlaceholder: '{{columns, list}}',
  Security: 'Security',
  SecurityCheck: {
    Title: 'Security check',
    Message: 'Enter your credentials to proceed.',
    Proceed: 'Proceed',
  },
  Select: '- select -',
  SelectAllPermissions: 'Select all permissions',
  SelectDICOMFile: 'Select DICOM file',
  SelectDosimetryAndQAEquipmentForTaskPerformance:
    'Select QA equipment that should be available for task performance.',
  SelectDosimetryAndQaEquipment: 'Select QA equipment',
  SelectDosimetryQaEntity: 'Select QA equipment',
  SelectEvaluationQuantityOrEnumeration: 'Select quantity / enumeration',
  SelectMedicalSystem: 'Select medical system',
  SelectMedicalSystemForTargetAreaNotification:
    'Please note that only parameters and settings relevant to the new medical system will be duplicated. If the setup parameter "Beam quality" is configured, please note that only beam quality and dose rate available to the new medical system will be transferred to the new target area.',
  SelectMedicalSystemForTargetAreaText:
    'Select a medical system to which this target area shall be applied. Duplicating the target area creates a new target area with the same settings and values that apply to the new medical system.',
  SelectMedicalSystemForTask: 'Select a medical system for which the task is to be performed.',
  SelectMedicalSystemForTaskPerformance: 'No medical system selected.',
  SelectNewMedicalSystemNotification:
    'Please note that only parameters and settings compatible with the new medical system will be transferred. If the setup parameter "Beam quality" is configured, only beam quality and dose rate supported by the new medical system will be applied to the new target area.',
  SelectOneInterfaceAndOneArrayMsg:
    'Select exactly <strong>one detector interface</strong> and <strong>one array detector</strong> per group.',
  SelectQuantitiesOrEnumerationsForTaskPerformance: 'No evaluations selected.',
  SelectRequiredDosimetryAndQEquipment: 'No QA equipment selected.',
  SelectScope: 'Select scope',
  SelectSupportSystem: 'Select QA equipment',
  SelectTaskItem_one: 'Select task item',
  SelectTaskItem_other: 'Select task items',
  SelectWorkItem_one: 'Select work item',
  SelectWorkItem_other: 'Select work items',
  Selected: 'Selected',
  Send: 'Send',
  SendActivationLink: 'Send activation link',
  SendInstructions: 'Send instruction',
  SendInvitation: 'Send invitation',
  SendLater: 'Send later',
  SendNow: 'Send now',
  SendTestEmail: 'Send test email',
  SendToReview: 'Send to review',
  SenderEmail: 'Sender email',
  SenderName: 'Sender name',
  SendingActivationFailed: 'Sending activation mail failed',
  SendingActivationFailedMsg: 'Activation link for {{userFullNameWithIuid}} could not be sent.',
  SendingActivationSuccessful: 'Sending activation mail successful',
  SendingActivationSuccessfulMsg: 'Activation link sent to {{userFullNameWithIuid}}',
  SendingInvitationFailed: 'Sending invitation failed',
  SendingInvitationFailedMsg: 'Sending invitation to {{emailAddress}} failed!',
  SendingInvitationSuccessful: 'Sending invitation successful',
  SendingInvitationSuccessfulMsg: 'Invitation succesfully sent to {{emailAddress}}',
  SequenceMeasurementDialogTitle: 'Measurement sequence',
  SerialNumber: 'Serial number',
  SerialNumberDisabledReasonTooltipMsg:
    'The serial number cannot be changed for devices that are in use or have already been registered.',
  SerialNumberOrDpin: 'Serial Number / DPIN',
  SerialNumberTooltipMsg:
    'The serial number is located on the device. You can change the serial number until the equipment is registered.',
  SeriesPeriod: 'Series period',
  Server: 'Server',
  Session: 'Session',
  SetDateFiltersMsg: 'Please set both start and end dates to see results',
  SetValidDateRangeMsg:
    'Please set a valid date range to see results. Start date must be before end date.',
  SettingManagementNavigationMsg: 'Configure email settings, DICOM, and security.',
  Settings: 'Software settings',
  SettingsDescriptionMsg: 'Manage software settings.',
  SetupCategory_one: 'Setup category',
  SetupCategory_other: 'Setup categories',
  SetupCombinationsMeasurementMissingMessage: 'Reference measurement missing',
  SetupCombinationsParametersChangedMessage:
    'Due to a change in the setup parameters of the medical system and/or the QA equipment, the setup combinations need to be updated.',
  SetupCombinationsParametersChangedNotification: 'Update',
  SetupCombinationsParametersChangedTitle: 'Update required',
  SetupCombinationsParametersInvalid:
    'The setup is incomplete, so no valid setup combinations can be generated. Review the setup and ensure all required fields are filled and valid.',
  SetupCombinationsParametersInvalidTitle: 'Setup combinations cannot be updated',
  SetupCombinationsParametersQualitiesMissingMessage: 'At least one beam quality must be selected.',
  SetupCombinationsParametersQualitiesMissingTitle: 'Beam quality is required',
  SetupCombinationsQualityMissingMessage: 'At least one beam quality must be selected.',
  SetupCombinationsSelectionChangedMessage: 'Changes have been made to setup combinations.',
  SetupCombinationsSelectionChangedTitle: 'Confirmation required',
  SetupCombinationsSelectionChangedValidation:
    'The selection of setup combinations has been changed.',
  SetupCombinationsSetupMissingMessage:
    'Select a medical system and a UNICHECK. Setup parameters must be configured.',
  SetupCombinationsSetupMissingTitle: 'Setup parameter combination',
  SetupGeometry_one: 'Quantity specifier',
  SetupGeometry_other: 'Quantity specifiers',
  SetupParameterCombinations: 'Setup combinations',
  SetupParameterCombinationsGeneratedMsg: 'All available setup combinations are generated.',
  SetupParameterCombinationsMsg:
    'The task is to be performed for the following combination of setup parameters.',
  SetupParameters: 'Setup parameter',
  SetupParametersMightGoMissing:
    'Please note that only setup parameters that match the QA equipment selection can be assigned or displayed. Setup parameters which do not match will be automatically removed.',
  SetupType: 'Setup type',
  SetupTypeEnum: { Manual: 'Manual', QaEquipment: 'QA equipment', TreatmentPlan: 'Treatment plan' },
  Setup_one: 'Setup',
  Setup_other: 'Setups',
  Setups: 'Setups',
  ShowAllCells: 'Show all properties',
  ShowAllManufacturers: 'Show all manufacturers',
  ShowDeactivatedChambers: 'Show deactivated chambers',
  ShowDefinitionSetParameters: 'Show more',
  ShowFieldSizeLabels: 'Show field size labels',
  ShowLess: 'Show less',
  ShowLessDetails: 'Show less',
  ShowLicenseDetails: 'Show license details',
  ShowMore: 'Show more',
  ShowMoreDetails: 'Show more',
  ShowOnlyDifferences: 'Show only differences',
  ShowStatisticsBtn: 'Show Statistics',
  SignIn: 'Sign in',
  SignInErrorMsg:
    'Sign in failed. Please check your email address and password or contact your administrator.',
  SignInWelcomeMsg: 'Sign in welcome text',
  SignOut: 'Sign out',
  SignOutUsersAndProceed: 'Sign out users and proceed',
  Signature: 'Signature',
  SingleDetectorConnectorTypeEnum: {
    DetectorConnectionSystemBNT: 'BNT',
    DetectorConnectionSystemA: 'A',
    DetectorConnectionSystemBNCplus: 'BNC plus',
    DetectorConnectionSystemM: 'M',
    DetectorConnectionSystemTNC: 'TNC',
    DetectorConnectionSystemF: 'F',
    DetectorConnectionSystemIBA: 'IBA',
    DetectorConnectionSystemLEMO: 'LEMO',
    DetectorConnectionSystemV: 'V',
  },
  SingleDetectorConnectorTypeLabel: 'Connector type',
  SingleMeasurementDialogTitle: 'Measurement',
  SingleSetupParameters: 'Single setup parameter',
  SingleValuesSeparatedBySemicolonPlaceholder: 'Single values separated by ";"',
  SiteName: 'Site Name',
  SoftwareName: 'Software name',
  SoftwareSettings: {
    DatabaseChangeSuccessDialogTitle: 'Database changed',
    DatabaseSuccessfullyConnected: 'The database has been connected successfully.',
    DatabaseChangeSuccessSignOutMsg: 'You will be signed out and need to sign in again.',
  },
  SomeLicenseFeaturesHaveExpired: 'Some license features have expired',
  SomeLicenseFeaturesWillExpireIn_count_Days_one:
    'Some license features will expire in {{count}} day',
  SomeLicenseFeaturesWillExpireIn_count_Days_other:
    'Some license features will expire in {{count}} days',
  SomeTaskModifiedMsg: 'One of the tasks was modified',
  SortBy: 'Sort by',
  SoupOverviewTitle: 'Open Source Software Licenses',
  Source: 'Source',
  SourceToAxisDistance: 'Source-to-axis distance',
  SpecificDayAndTime: 'Specific day and time',
  StandardDeviation: 'Standard deviation',
  Start: 'Start',
  StartDate: 'Start date',
  StartJobExecution: 'Start',
  StartSequence: 'Start sequence',
  StartTime: 'Start time',
  StartUpdate: 'Start the update/upgrade',
  StartUpgrade: 'Start upgrade',
  StartZeroMeasurement: 'Start zero measurement',
  State: { Adding: 'Adding', Enabled: 'Enabled', InEditing: 'Being edited' },
  StateOfExecution: 'Status',
  StateOfUse: 'State of use',
  StateOfUseEnum: {
    Disabled: 'Disabled',
    Enabled: 'Enabled',
    InEditing: 'Being edited',
    NotRegistered: 'Not registered',
    ActivationPending: 'Activation pending',
    Archived: 'Archived',
    Deleted: 'Deleted',
    InAdding: 'Adding',
    NoActivationSent: 'No activation link sent',
    DeRegistered: 'Deregistered',
    Offline: 'Offline',
    Initializing: 'Initializing...',
    DeviceError: 'Device error',
    Online: 'Online',
    CommunicationError: 'Communication error',
    InUse: 'In use',
    Unknown: 'Unknown',
    New: 'New',
    InExecution: 'In execution',
    Paused: 'Paused',
    Completed: 'Completed',
    InReview: 'In review',
    ReviewPending: 'Sent for review',
    ReworkRequested: 'Rework requested',
    Approved: 'Approved',
    Measuring: 'In operation',
  },
  Statistics: 'Statistics',
  Status: 'Status',
  Stay: 'Stay',
  Storage: 'Storage',
  SubModel: 'Submodel',
  SubjectCommonName: 'Common name (CN)',
  Success: 'Success',
  SuccessfullySaved: 'Successfully saved.',
  Summary: 'Summary',
  SupportRequestMessagePlaceholder: 'Please describe your problem.',
  SupportSystemParameter_one: 'QA equipment setup parameter',
  SupportSystemParameter_other: 'QA equipment setup parameters',
  SupportSystem_one: 'QA equipment',
  SupportSystem_other: 'QA equipment',
  SurfaceDistance: 'UNICHECK is to be positioned with a source-to-surface distance of {{distance}}',
  SwitchOnTheDeviceMsg:
    'Switch on the UNICHECK. As soon as the LED lights up green in the UNICHECK Software, the device is connected. This requires a correct configuration of the device in your network. The network configuration instructions can be found in the user manual.',
  SwitchOnUnicheckAndConnectWithPtw100: 'Switch on UNICHECK',
  System: 'System',
  TargetAreaReferencedByJobsMsg:
    'This target area is already used in job configurations. \n\nChanges will affect those configurations.',
  TargetArea_one: 'Target area',
  TargetArea_other: 'Target areas',
  TargetSystem: 'Medical system',
  TargetSystemChangedMsg:
    'The medical system has been changed. Please review the selection and order of the work items and work steps.',
  TargetSystemParameter_one: 'Medical system setup parameter',
  TargetSystemParameter_other: 'Medical system setup parameters',
  TargetSystemSetup: 'Medical system setup',
  TaskCategory_one: 'Task category',
  TaskCategory_other: 'Task categories',
  TaskItemDescriptionDefaultValue:
    'QA test ensuring that the characteristics of a radiation beam are consistent and stable over time.',
  TaskItemOptionDescription: {
    ImagingMachine: {
      ManualTask: 'Create a manually configured task for imaging machine.',
      TrackItMeasurementImport: 'Import imaging machine measurement data from TrackIt',
    },
    OtherMedicalSystem: {
      ManualTask: 'Create a manually configured task for other data',
      TrackItMeasurementImport: 'Import other data from TrackIt',
    },
    PDMS: {
      ManualTask: 'Create a manually configured task for PIS',
      TrackItMeasurementImport: 'Import TPS data from TrackIt',
    },
    TPS: {
      ManualTask: 'Create a manually configured task for TPS',
      TrackItMeasurementImport: 'Import TPS data from TrackIt',
    },
    TreatmentMachine: {
      BeamConstancyCheck: 'Create a Beam Constancy Check task for treatment machine',
      ManualTask: 'Create a manually configured task for treatment machine',
      TrackItMeasurementImport: 'Import treatment machine measurement data from TrackIt',
    },
    Software: {
      ManualTask: 'Create a manually configured task for software',
      TrackItMeasurementImport: 'Import software data from TrackIt',
    },
  },
  TaskItemTypeEnum: {
    BeamConstancyCheck: 'Beam Constancy Check',
    ManualTask: 'Manual Task',
    ReferenceMeasurement: 'Reference measurement',
    TrackItMeasurementImport: 'TrackIt measurement import',
  },
  TaskItem_one: 'Task item',
  TaskItem_other: 'Task items',
  TaskItems: { Label: 'Task items' },
  TaskManagement: 'Protocols',
  TaskManagementDescriptionMsg: 'Manage protocols.',
  TaskModifiedMsg: 'Task was modified',
  TaskReferencesDescriptionMsg:
    'Any changes to the settings for this target area will be automatically applied to all linked job configurations. \n\nAll not yet executed work items will be updated or removed, even if the execution of the job has already started. Previously executed work items remain unchanged to preserve history.',
  TaskRemoveTargetAreaInfoMsg: 'Removing the target area has the following effects:\n{{effects}}',
  TaskReplaceTargetAreaInfoMsg:
    'Replacing the medical system within the target area has the following effects: {{effects}}',
  TaskScope: 'Task scope',
  TaskSelection: 'Task selection',
  TaskSelectionDialogTitle: 'Select work items',
  TaskSettings: 'Task settings',
  TaskStep_one: 'Work step',
  TaskStep_other: 'Work steps',
  TaskTargetAreaChangeEffects:
    'Related work items in jobs will also be deleted, unless they already contain results.',
  TaskTemplates: 'Task Templates',
  TaskTypeDescriptionEnum: {
    BeamConstancyCheck: 'Beam Constancy Check',
    ManualTask: 'Manual Task',
    BeamAnalysis: 'Beam Analysis',
  },
  TaskType_one: 'Task type',
  TaskType_other: 'Task types',
  Task_one: 'Task',
  Task_other: 'Tasks',
  Tasks: 'Tasks',
  Tenants: { Label: 'Tenants' },
  TestAndSave: 'Test & Save',
  TestEmailSettingsMsg:
    'Please provide a recipient email address to test your email server settings. Check your inbox after submitting the form.',
  TestRecipientEmailAddress: 'Test recipient email address',
  TextDescriptionLabelEnum: {
    IndexingPointMsg:
      'The locating bar is fitted in the side fixings at the desired position - the indexing position - on the couch.',
  },
  TextNameLabelEnum: { IndexingPoint: 'Indexing point' },
  TextNotUsedInSetupsMsg: 'This text is not used in setups.',
  Text_one: 'Text',
  Text_other: 'Texts',
  TheCertificateIsNotValid: 'The certificate is not valid.',
  TheCertificateIsValid: 'The certificate is valid.',
  TheDatabaseSelectionHasNotBeenChanged: 'The database selection has not been changed',
  TheDeviceCanNotBeDerigsteredWhileInUse: "The device can't be deregistered while it's in use.",
  TheDevicesLicenseHasExpired: 'The license for the device has expired.',
  TheDevicesLicenseIsMissing: 'Device license missing',
  TheDevicesLicenseWillExpireIn_count_Days_one:
    'The license for the device expires in {{count}} day.',
  TheDevicesLicenseWillExpireIn_count_Days_other:
    'The license for the device expires in {{count}} days.',
  TheEndDateCannotBeBeforeTheStartDate: 'The end date cannot be before the start date.',
  TheFollwing_count_DevicesLicensesHaveExpired: '{{count}} device licenses have expired',
  TheFollwing_count_DevicesLicensesWillExpireSoon_one: '{{count}} device license will expire soon',
  TheFollwing_count_DevicesLicensesWillExpireSoon_other:
    '{{count}} device licenses will expire soon',
  TheServerIsRebooting: 'The server is rebooting.',
  TheServerIsWaitingForAReboot: 'The server is waiting for a reboot',
  TheStartDateCannotBeAfterTheEndDate: 'The start date cannot be after the end date.',
  The_updateType_CouldNotBeApplied: 'The {{updateType}} could not be applied!',
  The_updateType_WasComletedSuccessfully: 'The {{updateType}} was completed successfully!',
  ThisConfirmationIsRequired: 'This confirmation is required.',
  ThisIsNotAValidEmailAddress: 'This is not a valid email address.',
  ThisSectionHasErrors: 'Some fields contain errors. Please review and correct them.',
  TimeRange: 'Time range',
  TimeRangeFilterOption: { today: 'Today', next7days: 'Next 7 days', next30days: 'Next 30 days' },
  Timezone: 'Time zone',
  Timezones: 'Time zones',
  Title: 'Title',
  To: 'To',
  ToActivateAccountSetPasswordMsg:
    'Welcome to UNICHECK Software!\n\nTo activate your account please set a password.',
  ToResetAccountSetPasswordMsg:
    'To reset the password of your user account,\nplease enter a new password below.',
  Today: 'Today',
  TooManySetupCombinationsMessage:
    'Limit the selection of the setup parameters for your medical system and/or QA equipment in order to generate setup combinations. ({{total}} found, {{max}} allowed)',
  TooManySetupCombinationsTitle: 'Too many setup combinations found',
  TrackItMeasuringDevice: 'Measuring device',
  TrackItMeasuringSoftware: 'Software',
  TransferBackupInstructionsMsg:
    'The database backup files have been successfully created!\n\nYou can transfer them using the Secure Copy Protocol (SCP) or the SSH File Transfer Protocol.',
  TrashManagementNavigationMsg:
    'Storage of deleted data with the option to restore or permanently delete it.',
  TreatmentMachineSetup: { WedgeFilterInfo: '{{0}} wedge filters are defined in this beam.' },
  TreatmentMachineType: 'Treatment machine type',
  Trends: 'Trends',
  TryAgain: 'Try again',
  TypeNumber: 'Type number',
  TypeSpecification: 'Type specification',
  Type_one: 'Type',
  Type_other: 'Types',
  Unicheck: 'UNICHECK',
  UnicheckSoftware: 'UNICHECK Software',
  UnitDescriptionLabelEnum: {
    PercentMsg: 'Percent is a number or ratio expressed as a fraction of 100.',
    CentimeterMsg:
      'Centimeter is a submultiple of the SI unit meter which is the base unit of the SI quantity length.\n1 m = 100 cm',
    MillimeterMsg:
      'Millimeter is a submultiple of the SI unit meter which is the base unit of the SI quantity length.\n1 m = 1000 mm',
    DegreeCelciusMeteoMsg:
      'Degree Celsius is an SI-derived unit of the SI quantity Celsius temperature.',
    DegreeMathMsg: 'Degree is a non-SI unit of the SI quantity plane angle. \n1° = (π/180) rad',
    HectopascalMsg:
      'Hectopascal is a multiple of the SI-derived unit pascal which is the base unit of the SI quantity pressure.\n1 hPa = 100 Pa',
    MegavoltMsg:
      'Megavolt is a multiple of the SI-derived unit volt which is the base unit of the SI quantity electric potential difference.\n1 MV = 1 000 000 V',
    MegaElectronvoltMsg:
      'Megaelectronvolt is a multiple of the non-SI unit electronvolt which is the base unit of the SI quantity energy.\n1 MeV = 1 000 000 eV',
    MonitorUnitMsg:
      'Monitor unit is a measure of the radiation output of a clinical accelerator or orthovoltage unit measured by a built-in monitor ionization chamber. 1 MU is equal to a certain absorbed dose measured under defined reference conditions.',
    MonitorUnitPerMinuteMsg:
      'Monitor units per minute is a measure of the radiation output per time of a clinical accelerator or orthovoltage unit output.',
    GrayMsg: 'Gray is an SI-derived unit of the SI quantities absorbed dose and kerma.',
  },
  UnitEnum: {
    WorkPoint: 'WP',
    LengthUnit: { Centimeter: 'Centimeter', Millimeter: 'Millimeter' },
    RatioUnit: { Percent: 'Percent' },
    Temperature: { DegreeCelciusMeteo: 'Degree Celsius' },
    AngleUnit: { DegreeMath: 'Degree [math.]' },
    Pressure: { Hectopascal: 'Hectopascal' },
    ElectricPotentialUnit: { Megavolt: 'Megavolt' },
    EnergyUnit: { MegaelectronVolt: 'Megaelectronvolt' },
    MonitorUnit: { MonitorUnit: 'Monitor unit' },
    MonitorUnitRate: { MonitorUnitPerMinute: 'Monitor unit per minute' },
    AbsorbedDoseToWater: { Gray: 'Gray' },
  },
  UnitSymbol: 'Unit symbol',
  UnitSymbolInfoDisabledMessage: 'This unit is already in use and cannot be modified.',
  UnitSymbolInfoMessage: 'Every alphanumeric and special character can be entered',
  Unit_one: 'Unit',
  Unit_other: 'Units',
  Units: { Label: 'Units' },
  UnknownErrorHasOccurred: 'Unknown error has occurred',
  Unregister: 'Unregister',
  Untitled: 'Untitled',
  Update: 'Updates',
  UpdateFromVersionToVersion: 'From {{installedVersion}} to {{targetVersion}}',
  UpdateInformationStepBackupMsg:
    'All data and settings are retained after the update. However, for security reasons, we strongly recommend that you make a complete backup of the UNICHECK Software before updating.',
  UpdateInformationStepBackupWarning:
    'Before proceeding with the update, please create a full backup of your system to ensure data integrity in case of unexpected problems.\n',
  UpdateInformationStepMaintenanceMsg:
    'Please note that the maintenance mode is automatically activated when the update is started. During this time, the UNICHECK Software is not available for use. Users will be able to use the software when the update has been completed and the maintenance mode has ended.',
  UpdateStatusStepFailedHeader: 'Update failed',
  UpdateStatusStepMsg: 'Please keep this window open to track the progress of the update.',
  UpdateStatusStepSuccessNotification:
    'The UNICHECK Software has been successfully updated to version {{version}}.',
  UpdateUpgradeEulaMsg: 'Please read and confirm the End User License Agreement (EULA) to proceed.',
  UpdateUpgradeEulaStepHeader: 'Agree to End User License Agreement (EULA)',
  UpdateUpgradeEulaStepLink: 'End User License Agreement (EULA)',
  UpdateUpgradeInformationStepBackupHeader: 'Backup',
  UpdateUpgradeInformationStepHeader: 'Upgrade information / notes',
  UpdateUpgradeInformationStepMaintenanceHeader: 'Maintenance mode',
  UpdateUpgradeInformationStepMaintenanceWarning:
    'During the maintenance mode, you cannot sign in to the UNICHECK Software. Currently signed in users may lose their changes!',
  UpdateUpgradeSecurityStepHeader: 'Security check',
  UpdateUpgradeSecurityStepMsg: 'Enter your credentials to proceed.',
  UpdateUpgradeStatusStepSuccessNotificationTitle: 'Congratulations!',
  UpdateUpgradeStatusTimeHint: 'This will take up to 15 minutes.',
  UpdateWelcomeStepHeader: 'Welcome to the UNICHECK Software update wizard',
  UpdateWelcomeStepMsg:
    'The wizard will guide you through the update of the UNICHECK Software version {{version}}. Please follow the steps to ensure your systems are up to date and fully optimized.\n\nDuring the update, users will not be able to work with the UNICHECK Software.\n\nPlease make sure that the UNICHECK Software remains connected to the PTW Cloud services for the duration of the update.\n\nClick "Next" to start the update.',
  UpdatesAndUpgrades: 'Updates and upgrades',
  Upgrade: 'Upgrade',
  UpgradeFromVersionToVersion: 'From {{installedVersion}} to {{targetVersion}}',
  UpgradeInformationStepBackupConfirm: 'I confirm the backup recommendations.',
  UpgradeInformationStepBackupMsg:
    'All data and settings are retained after the update. However, for security reasons, we strongly recommend that you make a complete backup of the UNICHECK Software before upgrading.',
  UpgradeInformationStepBackupWarning:
    'Before proceeding with the upgrade, please create a full backup of your system to ensure data integrity in case of unexpected problems.',
  UpgradeInformationStepMaintenanceMsg:
    'Please note that the maintenance mode is automatically activated. As long as it is active, the UNICHECK Software is not available for use. The maintenance needs to be manually disabled to restore access to the users.',
  UpgradeStatusStepFailedHeader: 'Upgrade failed',
  UpgradeStatusStepHeader: 'Upgrade in progress',
  UpgradeStatusStepMsg: 'Please keep this window open to track the progress of the upgrade.',
  UpgradeStatusStepSuccessHeader: 'Upgrade successfull',
  UpgradeStatusStepSuccessMsg:
    'To complete the upgrade, you must sign in to the UNICHECK Software again.\nAfter clicking sign in you will be signed out automatically.',
  UpgradeStatusStepSuccessNotification:
    'The UNICHECK Software has been successfully upgraded to version {{version}}.',
  UpgradeWelcomeStepHeader: 'Welcome to the UNICHECK Software upgrade wizard',
  UpgradeWelcomeStepMsg:
    'The wizard will guide you through the upgrade of the UNICHECK Software version {{version}}. Please follow the steps to ensure your systems are up to date and fully optimized.\n\nDuring the upgrade, users will not be able to work with the software.\n\nPlease make sure that the UNICHECK Software remains connected to the PTW Cloud services for the duration of the upgrade.\n\nClick "Next" to start the upgrade.',
  Upload: 'Upload',
  UploadAndActivateCalibrationFile: 'Upload and activate calibration file',
  UploadAndActivateLatestCalibrationFileMsg:
    'Please upload and activate the latest calibration file to perform measurements.',
  UploadCalibrationCertificateFromLocalSystemMsg:
    'Upload the calibration certificate from your local system.',
  UploadCalibrationFile: 'Upload calibration file',
  UploadCalibrationFileAssociatedWithLatestCalibrationMsg:
    'Upload the calibration file associated with the latest calibration.',
  UploadCalibrationFileSuccessMsg: 'Calibration file uploaded and activated.',
  UploadFailedMsg: 'Upload failed, please try again.',
  UploadFailedOnLeaveMsg:
    'An error occurred during file upload; the upload is not finished. Either retry or cancel the upload.',
  UploadInProgressMsg: 'Currently uploading',
  UploadNewSSLCertificateMsg:
    'The connection between the client (Web Browser) and the server needs to be encrypted. This is done by uploading a TLS certificate and providing the password with which it was encrypted.',
  UploadPendingOnLeaveMsg:
    'The file upload is not finished yet. Either wait until it is finished or cancel it.',
  UploadPictureError_accept_Msg:
    'Failed to upload picture. Supported file formats are {{accept}}. The maximum allowed file size is 10 MB.',
  UploadSSLCertificate: 'Upload TLS certificate',
  Uploaded: 'Uploaded',
  UpperFailedLimit: 'Upper failed limit',
  UpperQuartile: 'Upper quartile',
  UpperWarningLimit: 'Upper warning limit',
  UseArrowButtonsOnKeyboard: 'Use the left and right arrow keys to scroll.',
  UseDefaultCredentials: 'Use default credentials',
  UseInEvaluation_one: 'Use in evaluation',
  UseInEvaluation_other: 'Use in evaluations',
  UseInSetupCategory_one: 'Setup category',
  UseInSetupCategory_other: 'Setup categories',
  UseInSetup_one: 'Use in setup',
  UseInSetup_other: 'Use in setups',
  UseInTaskCategory_one: 'Task category',
  UseInTaskCategory_other: 'Task categories',
  UseIndexing: 'Use indexing',
  UseSetupGeometry_one: 'Use quantity specifier',
  UseSetupGeometry_other: 'Use quantity specifiers',
  UseSsl: 'Use TLS',
  User: {
    NewPasswordMustBeDifferentThenLastXPasswords:
      'This password must be different from your previous {0} password',
    User: 'User',
  },
  UserAccountAndSignIn: 'User account & Sign in',
  UserAccountMsg: 'To finish the installation, you need to create a unique admin account.',
  UserAccount_one: 'User account',
  UserAccount_other: 'User accounts',
  UserAccounts: 'User accounts',
  UserId: 'User ID',
  UserLogins: { Label: 'User logins' },
  UserManagement: 'User management',
  UserManagementDescriptionMsg: 'Manage user accounts and roles.',
  UserName: 'User name',
  UserNameOrEmailIsUsedOnMultipleTenants: 'User name or email address is used on multiple tenants',
  UserStateEnum: {
    Activated: 'Activated',
    ActivationPending: 'Activation pending',
    Archived: 'Archived',
    NoActivationSent: 'No activation sent',
  },
  UserStateOfUseEnum: {
    ActivationPending: 'Activation pending',
    Archived: 'Archived',
    Deleted: 'Deleted',
    Disabled: 'Disabled',
    Enabled: 'Enabled',
    InAdding: 'Adding',
    InEditing: 'Being edited',
    NoActivationSent: 'No activation link sent',
  },
  Username: 'User name',
  Validation: {
    EmailAddressIsNotValid: 'Please enter a valid email address.',
    HasReferencedObjects: 'This entity is used in the software and cannot be deleted.',
    LocationChildrenAvoidDelete:
      'Location cannot be deleted because not all subordinate locations can be deleted.',
    RoleCannotBeDeleted: '{{0}} role cannot be deleted.',
    RoleDisplayNameAlreadyExisting: 'Display name already exists in a different role.',
    RoleNameAlreadyExisting: 'This name already exists in a different role.',
    RolesInfoTextPredefinedRoles:
      'Option is disabled because predefined roles cannot be archived nor deleted.',
    RolesInfoTextSystemRoles: 'All options are deactivated as the system roles cannot be changed.',
    StateChangeFailedReason: 'Cannot change state from {{0}} to {{1}}.',
    UserCannotBeDeleted: '{{0}} This user cannot be deleted.',
    UserCannotSetOwnState:
      'You cannot assign a different status to your own user account yourself.',
    UserHasLogins: 'User has already been signed in.',
    UserHasNoLogins: 'User has never been signed in.',
    BeamQualitiesNotUnique: 'This beam quality already exists.',
    BeamQualitiesRadiationEnergyDiffer: 'Radiation type and energy unit do not match.',
    PropertyRequired: 'This field is required.',
    YouCanNotDeleteOwnAccount: 'You cannot delete your own user account.',
    YouCanNotSetAvailabilityOfOwnAccount:
      'You cannot set the availability of your own user account.',
    ValueOutOfRange: 'The input value is out of range.',
    Name0NotUnique: 'The name {{name}} is not unique.',
    MaximumLengthExceeded: 'The value has more characters than permitted.',
    TypeMismatchChannelSubscription:
      'Type mismatch between ChannelSubscription and the Channel that it subscribes to.',
    ThisFieldMustBeUnique: 'This field must be unique.',
    TheDateMustHaveTheFormatYyyyMmDd: 'The date must have the format YYYY, YYYY-MM or YYYY-MM-DD.',
    ProtocolWithTheNameAndDateAlreadyExists:
      'A protocol with the name and the publication date already exists.',
    InputRangeMinMax: 'Minimum value cannot be greater than maximum value.',
    InvalidRadiationType: 'Invalid radiation type',
    OneDefinitionMustBeDefine: 'At least one definition is required.',
    UnknownOption: 'Unknown option',
    DpinFormatError: 'DPIN must be a 5-digit number.',
    SerialNumberFormatError: 'The format of the serial number is invalid.',
    ConnectionStringServer:
      'The server name may contain uppercase and lowercase letters, digits, dashes, and periods. You can also prefix it with one of the following protocols: "tcp:", "np:" or "lpc:".',
    ConnectionStringDatabase:
      'The database name may contain uppercase and lowercase letters, digits, and dashes.',
    Maximum:
      'The input exceeds the maximum allowed value of {{limit}}. Please enter a smaller value.',
    Minimum:
      'The input is below the minimum allowed value of {{limit}}. Please enter a larger value.',
    TableMustBeUpdated: 'Update the setup combinations to save the task.',
    NoArrayDetectorSelected: 'At least one UNICHECK must be selected.',
    OneBeamShapingMustBeSelected: 'At least one beam shaping must be selected.',
    ValuesMustBeInAscendingOrder: 'The values must be in ascending order.',
    ItemsMustBeDisjunct: 'The items must be disjunct.',
    DatesAndTimesMustBeChronologicallyOrdered: 'Dates and times must be in chronological order',
    JobScheduleResultsInNoOccurrenceMsg: 'This schedule information results in no job!',
    AtLeastOneUserOrRoleRequired: 'At least one user or role is required.',
    PropertyNotEditableHavingDependencies:
      'The property {{propertyName}} cannot be updated as there are dependencies.',
    NumberOfValuesNotMatchDefinitionParameters:
      'Number of values does not match number of definition parameters.',
    OrderOfRangesNotValid: 'The lower range field sizes must be in the correct order.',
    AtLeastOneItemMustBeSelected: 'At least one item must be selected.',
    AtLeastOneLimitValueMustBeSet: 'At least one limit value must be set.',
    DoseRatesNotUnique: 'Dose rate must be unique.',
    RoleToEditUserAccountsMustBeAssigned: 'A role to edit user accounts must remain assigned',
    PtwListMinLengthAttributeMsg: 'Fewer items selected than required.',
    UpdateReadonlyPropertiesNotAllowed: 'Update of read-only properties is not allowed.',
    JobConfigurationTaskItemAreaWasRemoved: 'Incompatible work item',
    JobConfigurationTaskItemAreaWasModified: 'The corresponding task item area has been modified!',
    MinLength: 'The value must consist of at least {{limit}} characters',
    StringMinLength: 'The value entered has too few characters.',
    RequestBodyIsNotValidJson: 'The request body provided is not valid JSON.',
    FieldValueHasInvalidFormat: 'The field value has an invalid format.',
    RequestBodyIsRequired: 'The request body is required',
    CombinationNotSatisfyingAnyCondition:
      'The setup parameter combination does not satisfy the condition of any evaluation scope.',
    EvalutionScopeNotSatisfiedByAnyCombination:
      'The evaluation scope condition is not satisfied by any setup parameter combination.',
    InvalidPublicationDate: 'Invalid publication date',
    MinutesOutOfRange: 'Minutes must be between 0 and 59.',
  },
  ValidationValueAboveMaxValue: 'Input must be less than or equal to {{maxValue}} {{unit}}.',
  ValidationValueBelowMinValue: 'Input must be greater that or equal to {{minValue}} {{unit}}.',
  ValidationValueNotInRange:
    'Input must be in the range {{minValue}} {{unit}} - {{maxValue}} {{unit}}.',
  Validity: 'Validity',
  Value: 'Value',
  ValueOneMustBeLessThanOrEqualTwoValueTwo:
    'Value {{valueOne}} must be smaller than or equal to {{valueTwo}}',
  ValueTwoMustBeGreaterThanOrEqualToValueOne:
    'Value {{valueTwo}} must be greater than or equal to {{valueOne}}',
  ValueType: 'Value type',
  VerifyCorrectCalibrationFileMsg:
    'Please ensure that the correct calibration file is selected and uploaded from your local system. PTW Freiburg assumes no responsibility for the correctness of the uploaded file.',
  VerifyCorrectCalibrationFileTitle: 'Verify correct calibration file',
  Version: 'Version',
  View: 'View',
  ViewDataSetDiagram: 'View trend',
  ViewDetail_one: 'View detail',
  ViewDetail_other: 'View details',
  WaitUntiluploadFinishedMsg: 'Either wait until it is finished or cancel it.',
  Warning: 'Warning',
  Warning_Cause_Measurement_ConnectionLost: 'The server is not reachable.',
  Warning_Message_Measurement_ConnectionLost: 'No connection',
  Warning_Remedy_Measurement_ConnectionLost: 'Please ensure network connectivity to the server.',
  Week_one: 'week',
  Week_other: 'weeks',
  Weekdays: 'Weekdays',
  WelcomeToPTW100: 'Welcome to UNICHECK Software',
  WithSerialNumber_serialNumber_ExpiresIn_count_Days_one:
    'with serial number {{serialNumber}} expires in {{count}} day',
  WithSerialNumber_serialNumber_ExpiresIn_count_Days_other:
    'with serial number {{serialNumber}} expires in {{count}} days',
  WithSerialNumber_serialNumber_HasExpired: 'with serial number {{serialNumber}} has expired',
  WorkItem_one: 'Work item',
  WorkItem_other: 'Work items',
  WorkList: 'Worklist',
  WorkManagement: 'Work management',
  Workflows: { Label: 'Workflows' },
  WorklistManagement: 'Worklist management',
  Workstep: 'Work step',
  WrongFormat: 'Wrong format',
  YearMonthDay: 'YYYY-MM-DD',
  Year_one: 'year',
  Year_other: 'years',
  Yes: 'Yes',
  YouAreAlreadyRunningTheLatestVersion:
    'You are already running the newest version ({{installedVersion}}).',
  YouCanOnlySelectDosimetryAndQaEquipmentThatHasBeenAdded:
    'Only QA equipment that has been added from the product catalogue is displayed in the list.',
  YouMustProvideAtLeastOneParameterValueSet:
    'At least one definition parameter preset is required.',
  YourEquipmentIsOfflineMsg: 'Your UNICHECK is offline. Please switch on the UNICHECK to connect.',
  YourLicenseIsAboutToExpireSoon: 'Your license will expire soon',
  YourLicenseWillExpireIn_count_DaysMsg_one:
    'Your license will expire in {{count}} day. After that you cannot sign in to the UNICHECK Software anymore. Please make sure to export all data that are still needed.',
  YourLicenseWillExpireIn_count_DaysMsg_other:
    'Your license will expire in {{count}} days. After that you cannot sign in to the UNICHECK Software anymore. Please make sure to export all data that are still needed.',
  YourUnicheckDeviceIsOnlineMsg: 'Your UNICHECK device is now online and ready to use.',
  ZeroMeasurement: 'Zero measurement',
  ZeroMeasurementDialogTitle: 'Zero measurement',
  ZeroMeasurementDuration: 'Measurement duration',
  CancelZeroMeasurement: 'Cancel zero measurement',
  CancelZeroMeasurementConfirmation: 'Cancel the running zero measurement?',
  ZeroMeasurementCompleted: 'Zero measurement completed',
  ZeroMeasurementBlockedInterfaceBusy: 'Detector interface is busy measuring',
  ZeroMeasurementBlockedInterfaceOffline: 'Detector interface is offline',
  ZeroMeasurementBlockedNoArray: 'No array detector connected',
  ZeroMeasurementValidFor: 'Zero measurement valid for {{duration}}',
  ZeroMeasurementValidityDuration: 'Validity duration',
  ZeroMeasurementStatusShort: {
    Initializing: 'Preparing device',
    ZeroMeasuring: 'Measuring',
    Finished: 'Completed',
  },
  Zxcvbn: {
    Warnings: {
      Common: 'This is a commonly used password.',
      CommonNames: 'Common names and surnames are easy to guess.',
      Dates: 'Dates are easy to guess.',
      ExtendedRepeat: 'Repeated character patterns like "abcabcabc" are easy to guess.',
      KeyPattern: 'Short keyboard patterns are easy to guess.',
      NamesByThemselves: 'Single names or surnames are easy to guess.',
      Pwned: 'Your password was exposed by a data breach on the Internet.',
      RecentYears: 'Recent years are easy to guess.',
      Sequences: 'Common character sequences like "abc" are easy to guess.',
      SimilarToCommon: 'This is similar to a commonly used password.',
      SimpleRepeat: 'Repeated characters like "aaa" are easy to guess.',
      StraightRow: 'Straight rows of keys on your keyboard are easy to guess.',
      TopHundred: 'This is a frequently used password.',
      TopTen: 'This is a heavily used password.',
      UserInputs: 'Do not use personal or page related data.',
      WordByItself: 'Single words are easy to guess.',
    },
    Suggestions: {
      AllUppercase: 'Capitalize some but not all letters.',
      AnotherWord: 'Add more words that are less common.',
      AssociatedYears: 'Avoid years that are associated with you.',
      Capitalization: 'Capitalize more than the first letter.',
      Dates: 'Avoid dates and years that are associated with you.',
      L33t: "Avoid predictable letter substitutions like '@' for 'a'.",
      LongerKeyboardPattern:
        'Use longer keyboard patterns and change typing direction multiple times.',
      NoNeed:
        'You can create strong passwords without using symbols, numbers, or uppercase letters.',
      Pwned: 'If you use this password elsewhere, you should change it.',
      RecentYears: 'Avoid recent years.',
      Repeated: 'Avoid repeated words and characters.',
      ReverseWords: 'Avoid reversed spellings of common words.',
      Sequences: 'Avoid common character sequences.',
      UseWords: 'Use multiple words but avoid common phrases.',
    },
  },
  _count_DataSetsFound: 'YouAreAlreadyRunningTheLatestVersion',
  _count_DataSetsSelected: '{{count}} data sets selected',
  _updateType_Failed: '{{updateType}} failed',
  _updateType_Status: '{{updateType}} status',
  _updateType_Successful: '{{updateType}} successful',
  Detector: 'Detector',
  REF: 'REF',
  DetectorConfirmationTitle: 'Confirm the detector in use',
  DetectorConfirmationInstruction:
    'Check the type label on the detector and compare it with the selected set. Measuring with a different detector leads to invalid results.',
  DetectorConfirmationPickInstruction:
    'Several {{model}} arrays are registered. Select the serial number printed on the connected detector.',
  DetectorConfirmationStatement:
    'I confirm that {{model}}, SN {{serial}}, is set up at {{target}}.',
  DetectorConfirmationStatementNoTarget:
    'I confirm that {{model}}, SN {{serial}}, is the detector in use.',
  DetectorConfirmationConfirm: 'Confirm set',
  DetectorConfirmationConfirmed:
    '{{model}}, SN {{serial}}, confirmed as the detector in use.',
  DetectorConfirmationChange: 'Change',
  DetectorConfirmationMismatch:
    'SN {{serial}} belongs to the {{model}} “{{name}}”, not to the array of this set. Check the label on the detector and the selected set.',
  DetectorConfirmationReportedConnected:
    '{{interface}} reports a connected {{type}}.',
  DetectorConfirmationReportedNoArray:
    '{{interface}} reports no connected array.',
  DetectorConfirmationReportedOffline:
    '{{interface}} is offline and reports nothing.',
  DetectorConfirmationLookupFailed:
    'The registered arrays could not be loaded. Compare the serial number on the label with the set yourself.',
  ZeroMeasurementBlockedDetectorUnconfirmed:
    'Confirm the detector in use first',
} as const;
